import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Paper,
  TableContainer,
  Grid,
  Box,
} from "@mui/material";
import "./ProductionLine.css";
import { images, ProductionLineImages } from "../../config/images";

import {
  getAcConditioningStationDetails,
  getAllStationTopics,
  getAutoclaveStationDetails,
  getBatchId,
  getBatchStationTracking,
  getChlorinationStationDetails,
  getCuttingStationDetails,
  getElectricTestData,
  getExtraAcConditionerStationDetails,
  getHancoMachineStationDetails,
  getLeachingStationDetails,
  getProngOven1StationDetails,
  getProngOven2StationDetails,
  getProngOven3StationDetails,
  getProngOven4StationDetails,
  getProngOvenTrolleys,
  getStaticLeachingBins,
  getStaticLeachingStationDetails,
  getStationTopic,
  getStrippingStationDetails,
  getTumbleDrying1StationDetails,
  getTumbleDrying2StationDetails,
  getTunnelOvenStationDetails,
  getUIDPrintingDetails,
  getUltraSonicData,
  getVisualInspectionDetails,
  getWashineMachine1StationDetails,
  getWashineMachine2StationDetails,
  operatorList,
  updateAcConditionerStationDetails,
  updateAutoclave,
  updateChlorination,
  updateCutting,
  updateExtraAcConditionerStationDetails,
  updateHancoWashingStationDetails,
  updateLeachingDetails,
  updateProngOvenDetails,
  updateStaticLeaching,
  updateTunnelOvenStationDetails,
  updateWM1StationDetails,
  updateWM2StationDetails,
} from "./services";
import ProductionLineVisualInspection from "./ProductionLineVisualInspection";
import MqttData from "../MqttData";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import RobotParameter from "./RobotParameter";
import { toast, ToastContainer } from "react-toastify";
import { name } from "dayjs/locale/en";
import MultiSelectWithCheckbox from "../../components/ProductionLineCheckbox/ProductionLineCheckbox";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { options } from "numeral";

const ProductionLineChart = () => {
  const [open, setOpen] = useState(false);
  const [selectedStation, setSelectedStation] = useState(null);
  const [formData, setFormData] = useState({});
  const [topic, setTopic] = useState([]);
  const [trackingTopic, setTrackingTopic] = useState();
  const [trackingStationName, setTrackingStationName] = useState([]);
  const [mqttData, setMqttData] = useState([]);
  const [trackingMqttData, setTrackingMqtttData] = useState([]);
  const [stationPopup, setStationPopup] = useState([]);
  const [disableFieldFormData, setDisableFieldFormData] = useState({});
  const [trackingData, setTrackingData] = useState([]);
  const [batchIdData, setBatchIdData] = useState([]);
  const [stationLogs, setStationLogs] = useState([]);
  const [UpdateButtonData, setUpdateButtonData] = useState();
  const [uidPrintingData, setUidPrintingData] = useState([]);
  const [visualInspectionData, setVisualInspectionData] = useState([]);
  const [electricTestData, setElectricTestData] = useState([]);
  const [prongOvenTrollyData, setProngTrollyData] = useState([]);
  const [staticLeachingBinData, setStaticLeachingBinData] = useState([]);
  const [ultrasonicPopups, setUltrasonicPopups] = useState(false);
  const [ultrasonicTanks, setUltrasonicTanks] = useState([]);

  // Dipping popup
  const [dippingPopup, setDippingPopup] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [selectTrollyBatch, setSelecttrollyBatch] = useState([]);
  const hasFetched = useRef(false);
  const location = useLocation();
  const { userPermission } = useSelector((state) => state.userState);
  console.log("selectedBatchselectedBatch", batchIdData);

  const batchId = location?.state?.batch_types;
  const batchType = location?.state?.batch_type;
  const batchTypeData = location?.state?.batchTypeData;
  const stationName = location?.state?.stationName;
  const prevName = location?.state?.prevStation;
  const stationTopic = location?.state?.stationTopic;
  const scannedMachine = location?.state?.scannedMachine;

  console.log("scannedMachinescannedMachine",scannedMachine,selectedStation)

  const getUidDeails = async () => {
    try {
      const resp = await getUIDPrintingDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setUidPrintingData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };
  useEffect(() => {
    getProngOvenTrollyesData();
  }, [scannedMachine]);

  const getProngOvenTrollyesData = async () => {
    try {
      const resp = await getProngOvenTrolleys(scannedMachine || batchId);
      if (resp.data.success == true) {
        setProngTrollyData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };



  const handleUltrasonic = async () => {
    try {
      const resp = await getUltraSonicData(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setUltrasonicTanks(resp.data.payload);
      }
    } catch (error) {
      setUltrasonicPopups(false);
      toast.error(error.response.data.message);
      console.log("handleSubmit", error);
    }
  };
  useEffect(() => {
    getStaticLeachingBinsData();
  }, [scannedMachine]);

  const getStaticLeachingBinsData = async () => {
    try {
      const resp = await getStaticLeachingBins(scannedMachine);
      if (resp.data.success == true) {
        setStaticLeachingBinData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const getVisualInspection = async () => {
    try {
      const resp = await getVisualInspectionDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setVisualInspectionData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };

  const getElectricTestDataAPI = async () => {
    try {
      const resp = await getElectricTestData(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setElectricTestData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };

  const getLatestScannedQRs = () => {
    const existingScans = JSON.parse(localStorage.getItem("qrScans")) || [];

    const latestTrayScan = existingScans
      .filter((scan) => scan.type === "tray")
      .pop(); // Get the last scanned tray

    const latestStationScan = existingScans
      .filter((scan) => scan.type === "station")
      .pop(); // Get the last scanned station

    return {
      trayQR: latestTrayScan ? latestTrayScan.data : null,
      stationQR: latestStationScan ? latestStationScan.data : null,
    };
  };

  // Example usage:
  const latestQRs = getLatestScannedQRs();

  // useEffect(() => {
  //   const MatchQrCodeData = QrCodeData.find(
  //     (e) => e.process == selectedStation?.machineData
  //   );
  //   const qrData = MatchQrCodeData?.code?.find(
  //     (e) => e == latestQRs?.trayQR?.data
  //   );
  //   console.log("latestQRs", qrData);
  //   setUpdateButtonData(qrData);
  // }, [selectedStation?.machineData]);

  // useEffect(() => {
  //   // Retrive stored station logs from localStorage
  //   const localstorageData = JSON.parse(localStorage.getItem("stationLogs")) || [];

  //   setStationLogs(localstorageData); // Update state with station logs

  //   if (selectedStation?.machineData) {
  //     // Find if any entry in stationLogs matches selectedStation
  //     // const matchingStation = localstorageData.find(
  //     //   (log) => log.station_name === selectedStation.machineData
  //     // );

  //     // Check if the required fields exist
  //     if (localstorageData.transferred_to && localstorageData.tray_qr_code) {
  //       setUpdateButtonData(true);
  //     } else {
  //       setUpdateButtonData(false);
  //     }
  //   }
  // }, [selectedStation]); // Runs when selectedStation changes
  const isStation = localStorage.getItem("is_station_qr");
  useEffect(() => {
    console.log("sfklsdnfjksdnf", localStorage.getItem("is_station_qr"));

    console.log("isStationisStationisStation", isStation);
    if (isStation == "true") {
      console.log("sdihfuigdsfuig");
      setUpdateButtonData(true);
    } else if (isStation == "false") {
      console.log("dhfasjkdfhkdshf");
      setUpdateButtonData(false);
    }
  }, []);

  console.log("sdgfuisdfsd", UpdateButtonData);
  const [allStationData, setAllstationData] = useState([]);
  const [leachingData, setLeachingData] = useState([]);
  const [tunnelOvenData, setTunnelOvenData] = useState([]);
  const [strippingData, setStrippingData] = useState([]);
  const [staticLeachingData, setStaticLeachingData] = useState([]);
  const [staticBinData, setStaticBinData] = useState([]);
  const [washing1Data, setWashing1Data] = useState([]);
  const [tumbledrying1Data, setTumbleDrying1Data] = useState([]);
  const [tumbledrying2Data, setTumbleDrying2Data] = useState([]);
  const [prong1Data, setProng1Data] = useState([]);
  const [trollyData, setTrollyData] = useState([]);
  const [prong2Data, setProng2Data] = useState([]);
  const [prong3Data, setProng3Data] = useState([]);
  const [prong4Data, setProng4Data] = useState([]);
  const [autoClaveData, setAutoClaveData] = useState([]);
  const [cuttingData, setCuttingData] = useState([]);
  const [washing2Data, setWashing2Data] = useState([]);
  const [acConditioningData, setAcConditioningData] = useState([]);
  const [hancoMachine, setHancoMachine] = useState([]);
  const [chlorinationData, setChlorinationData] = useState([]);
  const [extraAcConditioningData, setExtraAcConditioningData] = useState([]);
  const [operatorListData, setOperatorListData] = useState([]);
  const { username } = useSelector((state) => state.userState);
  const mergedArray = mqttData ? [].concat(...Object.values(mqttData)) : [];

  const BatchData = JSON.parse(localStorage.getItem("batch_id") || "[]");
  console.log("BatchDataBatchData", BatchData);

  // useEffect(() => {
  //   if (staticBinData?.length > 0) {
  //     const selectedBins = staticBinData
  //       .filter((e) => Array.isArray(e.batch_type) && e.batch_type.length > 0)
  //       .map((e) => e.id);

  //     setSelected(selectedBins);
  //   }
  // }, [staticBinData]);

  // useEffect(() => {
  //   if (trollyData?.length > 0) {
  //     const selectedBins = trollyData
  //       .filter((e) => Array.isArray(e.batch_type) && e.batch_type.length > 0)
  //       .map((e) => e.id);

  //     setSelectTrolly(selectedBins);
  //   }
  // }, [trollyData]);

  const data = [
    { id: 1, binNo: "BIN 01", batchNo: "-", duration: "-" },
    { id: 2, binNo: "BIN 02", batchNo: "-", duration: "-" },
    { id: 3, binNo: "BIN 03", batchNo: "-", duration: "-" },
    { id: 4, binNo: "BIN 04", batchNo: "-", duration: "-" },
    { id: 5, binNo: "BIN 05", batchNo: "-", duration: "-" },
    { id: 6, binNo: "BIN 06", batchNo: "-", duration: "-" },
    { id: 7, binNo: "BIN 07", batchNo: "-", duration: "-" },
    { id: 8, binNo: "BIN 08", batchNo: "-", duration: "-" },
  ];

  const ProngOven = [
    { id: 1, binNo: "Left Trolly", batchNo: "I0001, I0002", duration: 3 },
    { id: 2, binNo: "Right Trolly", batchNo: "I0003, I0004", duration: 2 },
  ];
  const [selected, setSelected] = useState([]);
  const [trollySelected, setTrollySelected] = useState([]);
  const [selectedBin, setSelectedBin] = useState("");
  const [selectTrolly, setSelectTrolly] = useState("");

  // useEffect(() => {
  //   const defaultSelectedBin = staticBinData.find(
  //     (bin) => bin.batch.length > 0
  //   );

  //   if (defaultSelectedBin) {
  //     setSelected([defaultSelectedBin.id]); // Select the bin ID
  //     setSelectedBin(defaultSelectedBin.bin_no); // Set the bin number
  //     setSelectedBatch(defaultSelectedBin.batch); // Set the batch IDs
  //   }
  // }, [staticBinData]);

  let selectBatch = [];

  try {
    const storedBatchData = localStorage.getItem("batch_id");
    selectBatch = storedBatchData ? JSON.parse(storedBatchData) : [];
  } catch (error) {
    console.error("Error parsing batch_id from localStorage:", error);
    selectBatch = []; // Fallback to empty array
  }

  const handleSelect = (binId, binNo, batch) => {
    if (selected.includes(binId)) {
      setSelected([]); // Unselect if clicked again
      setSelectedBin(""); // Clear bin number
      setSelectedBatch([]); // Clear batch ID
      localStorage.removeItem("selectBatch");
    } else {
      const selectedBinData = staticBinData.find((bin) => bin.id === binId);
      setSelected([binId]); // Select only the clicked bin
      setSelectedBin(binNo); // Store bin number as string
      setSelectedBatch(selectedBinData?.batch || []); // Store batch ID array
      localStorage.setItem("selectBatch", JSON.stringify(batch || []));
    }
  };
  // useEffect(() => {
  //   const defaultSelectedTrolley = trollyData.find(
  //     (trolley) => trolley.batch.length > 0
  //   );

  //   if (defaultSelectedTrolley) {
  //     setTrollySelected([defaultSelectedTrolley.id]); // Select default trolley
  //     setSelectTrolly(defaultSelectedTrolley.bin_no); // Store trolley name
  //     setSelecttrollyBatch(defaultSelectedTrolley.batch); // Store batch IDs

  //   }
  // }, [trollyData]);

  // useEffect(() => {
  //   const savedBatch = JSON.parse(localStorage.getItem("selectBatch")) || [];
  //   if (savedBatch.length > 0) {
  //     const selectedTrolley = trollyData.find(trolley => trolley.batch === savedBatch);
  //     if (selectedTrolley) {
  //       setTrollySelected([selectedTrolley.id]);
  //       setSelectTrolly(selectedTrolley.bin_no);
  //       setSelecttrollyBatch(selectedTrolley.batch);
  //     }
  //   }
  // }, [trollyData]);

  const handleSelectData = (binId, binNo, batch) => {
    console.log("batchashduagsd", batch);
    if (trollySelected.includes(binId)) {
      setTrollySelected([]); // Unselect if clicked again
      setSelectTrolly(""); // Clear trolley name
      setSelecttrollyBatch([]); // Clear batch IDs
      localStorage.removeItem("selectBatch");
    } else {
      const selectedTrolley = trollyData.find(
        (trolley) => trolley.id === binId
      );
      console.log("lsdkfhjksdfjk", selectedTrolley, prongOvenTrollyData, binId);
      setTrollySelected([binId]); // Select only the clicked trolley
      setSelectTrolly(binNo); // Store trolley name
      setSelecttrollyBatch(selectedTrolley?.batch || []); // Store batch IDs from API response
      // localStorage.setItem("batch_id", selectedTrolley?.batch)
      localStorage.setItem("selectBatch", JSON.stringify(batch || []));
    }
  };

  const mergedTrackingArray = trackingMqttData
    ? [].concat(...Object.values(trackingMqttData))
    : [];

  console.log("mergedTrackingArraymergedTrackingArray", mergedTrackingArray);

  useEffect(() => {
    if (stationTopic) {
      setTrackingTopic(stationTopic);
    }
  }, [stationTopic]);

  const [isVisualInspection, setIsVisualInspection] = useState(false);

  const [status, setStatus] = useState({
    Dipping: "completed",
    "Out Feed Visual Inspection": "in-progress",
    Leaching: "pending",
    "Tunnel Oven": "pending",
    Stripping: "pending",
    "UID Printing": "pending",
    "Visual Inspection": "pending",
    "Static Leaching": "pending",
    "Tumble Drying": "pending",
    Washing: "pending",
    Cutting: "pending",
    Autoclave: "pending",
    "Prong Oven": "pending",
    "AC Conditioning": "pending",
    "Hanco washing": "pending",
    Chlorination: "pending",
    "Extra AC Conditioning": "pending",
    "Electrical Test": "pending",
    "Box Packing": "pending",
    "Poly Bag Policing": "pending",
    Pairing: "pending",
    Printing: "pending",
    "Final Visual Inspection": "pending",
  });

  useEffect(() => {
    operatorListDataAPI();
  }, []);

  const operatorListDataAPI = async () => {
    const resp = await operatorList();
    if (resp.status == 200 || resp.status == 201) {
      setOperatorListData(resp.data.payload);
    }
  };
  useEffect(() => {
    handleStationTracking();
  }, []);
  const handleStationTracking = async () => {
    try {
      const resp = await getBatchStationTracking(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTrackingData(resp.data.payload);
        setTrackingTopic(resp.data.station_topic);
        setTrackingStationName(resp.data.station_name);
      }
    } catch (error) {
      setTrackingData([]);
    }
  };
  const handleChangeData = (event, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: event.target.value,
    }));
    setDisableFieldFormData((prevData) => ({
      ...prevData,
      [fieldName]: event.target.value,
    }));
  };

  const navigate = useNavigate();

  useEffect(() => {
    const updatedFormData = {};

    if (stationPopup.fields) {
      stationPopup.fields.forEach((field) => {
        const tagValue = mergedArray.find(
          (f) =>
            f.machineName === stationPopup.DeviceMatch &&
            f.device_tag === field.deviceTag
        )?.tagValue;

        // Convert tagValue to "ALARM" or "Normal" if it's for EMERGENCY
        updatedFormData[field.name] =
          field.deviceTag == "EMERGENCY"
            ? tagValue == 0
              ? "Normal"
              : tagValue == 1
              ? "ALARM"
              : ""
            : tagValue ?? "";
      });
      stationPopup.fields.forEach((field) => {
        const tagValue = mergedTrackingArray.find(
          (f) => f.device_tag === field.deviceTag
        )?.tagValue;

        // Convert tagValue to "ALARM" or "Normal" if it's for EMERGENCY
        updatedFormData[field.name] =
          field.deviceTag == "EMERGENCY"
            ? tagValue == 0
              ? "Normal"
              : tagValue == 1
              ? "ALARM"
              : ""
            : tagValue ?? "";
      });
    }

    updatedFormData["leachingOperator"] = leachingData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["tunnelOvenOperator"] = tunnelOvenData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["strippingOperator"] = strippingData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["staticLeachingOperator"] = staticLeachingData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["tumble2Operator"] = tumbledrying2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["washing2Operator"] = washing2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["cuttingOperator"] = cuttingData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["autoClaveOperator"] = autoClaveData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog1StartOperator"] = prong1Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog1EndOperator"] = prong1Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["TumbleOperator"] = tumbledrying1Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog2StartOperator"] = prong2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog2EndOperator"] = prong2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["washingoperator"] = washing1Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["acConditionerOperator"] = acConditioningData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["hanco_operator"] = hancoMachine
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["chlorinationOperator"] = chlorinationData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog3StartOperator"] = prong3Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog3EndOperator"] = prong3Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["extraAcOperator"] = extraAcConditioningData
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog4StartOperator"] = prong2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);
    updatedFormData["prog4EndOperator"] = prong2Data
      .filter((option) => option.selected)
      .map((option) => option.operator);

    updatedFormData["leachingBatch"] = leachingData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["tunnelOvenBatch"] = tunnelOvenData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);

    // updatedFormData["operator"] = username ?? "";
    // updatedFormData["cycle_start_operator_name"] = username ?? "";
    updatedFormData["leaching_batch_no"] = leachingData
      ? leachingData.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["LeachingDataStartTime"] = leachingData
      ? leachingData[0]?.cycle_start_time
        ? dayjs(leachingData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["LeachingDataEndTime"] = leachingData
      ? leachingData[0]?.cycle_end_time
        ? dayjs(leachingData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["HotLeachingStartTime"] = leachingData
      ? leachingData[0]?.hot_leach_cycle_start_time
        ? dayjs(leachingData[0].hot_leach_cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["HotLeachingEndTime"] = leachingData
      ? leachingData[0]?.hot_leach_cycle_end_time
        ? dayjs(leachingData[0].hot_leach_cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["ColdLeachingStartTime"] = leachingData
      ? leachingData[0]?.cold_leach_cycle_start_time
        ? dayjs(leachingData[0].cold_leach_cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["ColdLeachingEndTime"] = leachingData
      ? leachingData[0]?.cold_leach_cycle_end_time
        ? dayjs(leachingData[0].cold_leach_cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["ColdLeachingConductivity"] =
      leachingData.length > 0
        ? leachingData[0].cold_leaching_conductivity ??
          leachingData[0].latest_cold_conductivity ??
          ""
        : "";

    updatedFormData["HotLeachingConductivity"] =
      leachingData.length > 0
        ? leachingData[0].hot_leaching_conductivity ??
          leachingData[0].latest_hot_conductivity ??
          ""
        : "";

    updatedFormData["tunnelOvenData_batch_no"] = tunnelOvenData
      ? tunnelOvenData.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["in_feed"] = tunnelOvenData
      ? tunnelOvenData[0]?.in_feed
        ? dayjs(tunnelOvenData[0].in_feed).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["out_feed"] = tunnelOvenData
      ? tunnelOvenData[0]?.out_feed
        ? dayjs(tunnelOvenData[0]?.out_feed).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tunnelOvenStartTime"] = tunnelOvenData
      ? tunnelOvenData[0]?.cycle_start_time
        ? dayjs(tunnelOvenData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tunnelOvenEndTime"] = tunnelOvenData
      ? tunnelOvenData[0]?.cycle_end_time
        ? dayjs(tunnelOvenData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["stripping_batch_no"] = strippingData
      ? strippingData.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["strippingStartTime"] = strippingData
      ? strippingData[0]?.cycle_start_time
        ? dayjs(strippingData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["strippingEndTime"] = strippingData
      ? strippingData[0]?.cycle_end_time
        ? dayjs(strippingData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["batch_no"] = tunnelOvenData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["staticleaching_batch_no"] = staticLeachingData
      ? staticLeachingData.map((e) => e.batch_type).join(",")
      : "";

    updatedFormData["staticLeachingConductivity"] =
      staticLeachingData.length > 0
        ? staticLeachingData[0]?.conductivity ??
          staticLeachingData[0]?.latest_conductivity
        : "";
    updatedFormData["staticLeachingStartTime"] = staticLeachingData
      ? staticLeachingData[0]?.cycle_start_time
        ? dayjs(staticLeachingData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["staticLeachingEndTime"] = staticLeachingData
      ? staticLeachingData[0]?.cycle_end_time
        ? dayjs(staticLeachingData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["washing1startTime"] = washing1Data
      ? washing1Data[0]?.cycle_start_time
        ? dayjs(washing1Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["washing1EndTime"] = washing1Data
      ? washing1Data[0]?.cycle_end_time
        ? dayjs(washing1Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["washing2StartTime"] = washing2Data
      ? washing2Data[0]?.cycle_start_time
        ? dayjs(washing2Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["Washing2EndTime"] = washing2Data
      ? washing2Data[0]?.cycle_end_time
        ? dayjs(washing2Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["hanco_start_time"] = hancoMachine
      ? hancoMachine[0]?.cycle_start_time
        ? dayjs(hancoMachine[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["hanco_end_time"] = hancoMachine
      ? hancoMachine[0]?.cycle_end_time
        ? dayjs(hancoMachine[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tumbleDryingBatch"] = tumbledrying2Data
      .filter((option) => option.selected)
      .map((option) => option.batch_type);

    updatedFormData["tumbleDrying1startTime"] = tumbledrying1Data
      ? tumbledrying1Data[0]?.cycle_start_time
        ? dayjs(tumbledrying1Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tumbleDrying1EndTime"] = tumbledrying1Data
      ? tumbledrying1Data[0]?.cycle_end_time
        ? dayjs(tumbledrying1Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["tumble2StartTime"] = tumbledrying2Data
      ? tumbledrying2Data[0]?.cycle_start_time
        ? dayjs(tumbledrying2Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tumble2EndTime"] = tumbledrying2Data
      ? tumbledrying2Data[0]?.cycle_end_time
        ? dayjs(tumbledrying2Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["tumble2Supervisor"] =
      tumbledrying2Data.length > 0 ? tumbledrying2Data[0]?.supervisor : "";
    updatedFormData["tumble2Time"] =
      tumbledrying2Data.length > 0 ? tumbledrying2Data[0]?.time_minutes : "";

    updatedFormData["prog1StartDate"] = prong1Data
      ? prong1Data[0]?.cycle_start_time
        ? dayjs(prong1Data[0].cycle_start_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog1StartTime"] = prong1Data
      ? prong1Data[0]?.cycle_start_time
        ? dayjs(prong1Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["prog1EndDate"] = prong1Data
      ? prong1Data[0]?.cycle_end_time
        ? dayjs(prong1Data[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog1EndTime"] = prong1Data
      ? prong1Data[0]?.cycle_end_time
        ? dayjs(prong1Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["autoClaveStartTime"] = autoClaveData
      ? autoClaveData[0]?.cycle_start_time
        ? dayjs(autoClaveData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["autoClaveEndTime"] = autoClaveData
      ? autoClaveData[0]?.cycle_end_time
        ? dayjs(autoClaveData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["autoClaveTimeMinutes"] =
      autoClaveData.length > 0 ? autoClaveData[0]?.cycle_time_minutes : "";

    updatedFormData["autoClaveSupervisor"] =
      autoClaveData.length > 0 ? autoClaveData[0]?.supervisor : "";
    updatedFormData["prog1Operator"] =
      prong1Data.length > 0 ? prong1Data[0]?.operator : "";
    updatedFormData["prong1Supervisor"] =
      prong1Data.length > 0 ? prong1Data[0]?.supervisor : "";

    updatedFormData["prog1TimeHours"] =
      prong1Data.length > 0 ? prong1Data[0]?.cycle_time_hours : "";

    updatedFormData["TumbleSupervisor"] =
      tumbledrying1Data.length > 0 ? tumbledrying1Data[0]?.supervisor : "";
    updatedFormData["TumbleTime"] =
      tumbledrying1Data.length > 0 ? tumbledrying1Data[0]?.time_minutes : "";

    updatedFormData["time_minutes"] =
      washing1Data.length > 0 ? washing1Data[0]?.time_minutes : "";
    updatedFormData["quantity"] = washing1Data
      ? washing1Data.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      : 0;

    updatedFormData["washingSupervisor"] =
      washing1Data.length > 0 ? washing1Data[0]?.supervisor : "";
    updatedFormData["washing2_batch_no"] = washing2Data
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["ac_batch_no"] = acConditioningData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["washing2TimeMinutes"] =
      washing2Data.length > 0 ? washing2Data[0]?.time_minutes : "";
    updatedFormData["washing2Quantity"] = washing2Data
      ? washing2Data.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      : 0;
    updatedFormData["washing2Supervisor"] =
      washing2Data.length > 0 ? washing2Data[0]?.supervisor : "";

    updatedFormData["hanco_time_minutes"] =
      hancoMachine.length > 0 ? hancoMachine[0]?.time_minutes : "";
    updatedFormData["hanco_quantity"] = hancoMachine
      ? hancoMachine.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      : 0;

    updatedFormData["hanco_supervisor"] =
      hancoMachine.length > 0 ? hancoMachine[0]?.supervisor : "";

    updatedFormData["autoClave_batch_no"] = autoClaveData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["prong1_batch_no"] = prong1Data
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["tumbledrying1_batch_no"] = tumbledrying1Data
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["washing1_batch_no"] = washing1Data
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["hancoMachine_batch_no"] = hancoMachine
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["class"] = strippingData
      ? strippingData?.map((e) => e.class_name).join(",")
      : "";
    updatedFormData["size"] = strippingData
      ? strippingData?.map((e) => e.size_name).join(",")
      : "";
    updatedFormData["operator"] =
      strippingData.length > 0 ? strippingData[0]?.operator : "";
    updatedFormData["supervisor"] =
      strippingData.length > 0 ? strippingData[0]?.supervisor : "";
    updatedFormData["water_level"] =
      washing1Data.length > 0 ? washing1Data[0].water_level : "";
    updatedFormData["washing2WaterLevel"] =
      washing2Data.length > 0 ? washing2Data[0].water_level : "";
    updatedFormData["hanco_water_level"] =
      hancoMachine.length > 0 ? hancoMachine[0].water_level : "";
    updatedFormData["cutting_batch_no"] = cuttingData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);

    updatedFormData["cuttingInFeed"] = cuttingData
      ? cuttingData[0]?.in_feed
        ? dayjs(cuttingData[0].in_feed).format("HH:mm:ss")
        : "--"
      : " ";
    updatedFormData["cuttingOutFeed"] = cuttingData
      ? cuttingData[0]?.out_feed
        ? dayjs(cuttingData[0].out_feed).format("HH:mm:ss")
        : "--"
      : " ";
    updatedFormData["cuttingStartTime"] = cuttingData
      ? cuttingData[0]?.cycle_start_time
        ? dayjs(cuttingData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : " ";
    updatedFormData["cuttingEndTime"] = cuttingData
      ? cuttingData[0]?.cycle_end_time
        ? dayjs(cuttingData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : " ";

    updatedFormData["acConditionerStartDate"] = acConditioningData
      ? acConditioningData[0]?.cycle_start_time
        ? dayjs(acConditioningData[0].cycle_start_time).format("YYYY-MM-DD")
        : "--"
      : "";
    updatedFormData["acConditionerStartTime"] = acConditioningData
      ? acConditioningData[0]?.cycle_start_time
        ? dayjs(acConditioningData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "";

    updatedFormData["acConditionerEndDate"] = acConditioningData
      ? acConditioningData[0]?.cycle_end_time
        ? dayjs(acConditioningData[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "";
    updatedFormData["acConditionerEndTime"] = acConditioningData
      ? acConditioningData[0]?.cycle_end_time
        ? dayjs(acConditioningData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "";

    updatedFormData["acConditionerRE"] = acConditioningData
      ? acConditioningData.map((e) => e.sc_re).join(",")
      : "";
    updatedFormData["acConditionerBinNo"] = acConditioningData
      ? acConditioningData.map((e) => e.bin_number).join(",")
      : "";
    updatedFormData["acConditionerqty"] = acConditioningData
      ? acConditioningData.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      : 0;
    updatedFormData["acConditionerGood"] = acConditioningData?.good;
    updatedFormData["acConditionerFail"] = acConditioningData?.fail;
    updatedFormData["acConditionerHold"] = acConditioningData.hold;

    updatedFormData["extraAcConditionerStartDate"] = extraAcConditioningData
      ? extraAcConditioningData[0]?.cycle_start_time
        ? dayjs(extraAcConditioningData[0].cycle_start_time).format(
            "YYYY-MM-DD"
          )
        : "--"
      : "--";
    updatedFormData["extraAcConditionerStartTime"] = extraAcConditioningData
      ? extraAcConditioningData[0]?.cycle_start_time
        ? dayjs(extraAcConditioningData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["extraAcConditionerEndDate"] = extraAcConditioningData
      ? extraAcConditioningData[0]?.cycle_end_time
        ? dayjs(extraAcConditioningData[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["extraAcConditionerEndTime"] = extraAcConditioningData
      ? extraAcConditioningData[0]?.cycle_end_time
        ? dayjs(extraAcConditioningData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["extraAcConditionerRE"] = extraAcConditioningData
      ? extraAcConditioningData.map((e) => e.sc_re).join(",")
      : "";
    updatedFormData["extraAcConditionerBinNo"] = extraAcConditioningData
      ? extraAcConditioningData.map((e) => e.bin_number).join(",")
      : "";
    updatedFormData["extraAcConditionerqty"] = extraAcConditioningData
      ? extraAcConditioningData.reduce(
          (sum, item) => sum + (Number(item.quantity) || 0),
          0
        )
      : 0;
    updatedFormData["extraAcConditionerGood"] = extraAcConditioningData?.good;
    updatedFormData["extraAcConditionerFail"] = extraAcConditioningData?.fail;
    updatedFormData["extraAcConditionerHold"] = extraAcConditioningData.hold;
    updatedFormData["extraAcoperator"] = extraAcConditioningData?.operator;
    updatedFormData["chlorination_batch_no"] = chlorinationData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["chlorinationReceipe"] = chlorinationData
      ? chlorinationData[0]?.recipe
      : "";

    updatedFormData["extra_batch_no"] = extraAcConditioningData
      .filter((option) => option.selected)
      .map((option) => option.batch_type);
    updatedFormData["prong2_batch_no"] = prong2Data
      ? prong2Data.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["prong3_batch_no"] = prong3Data
      ? prong3Data.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["prong4_batch_no"] = prong4Data
      ? prong4Data.map((e) => e.batch_type).join(",")
      : "";
    updatedFormData["chlorinationStartTime"] = chlorinationData
      ? chlorinationData[0]?.cycle_start_time
        ? dayjs(chlorinationData[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["chlorinationEndTime"] = chlorinationData
      ? chlorinationData[0]?.cycle_end_time
        ? dayjs(chlorinationData[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["prog2StartDate"] = prong2Data
      ? prong2Data[0]?.cycle_start_time
        ? dayjs(prong2Data[0].cycle_start_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog2StartTime"] = prong2Data
      ? prong2Data[0]?.cycle_start_time
        ? dayjs(prong2Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["prog2EndDate"] = prong2Data
      ? prong2Data[0]?.cycle_end_time
        ? dayjs(prong2Data[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog2EndTime"] = prong2Data
      ? prong2Data[0]?.cycle_end_time
        ? dayjs(prong2Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["prog2Operator"] =
      prong2Data.length > 0 ? prong2Data[0]?.operator : "";
    updatedFormData["prong2Supervisor"] =
      prong2Data.length > 0 ? prong2Data[0]?.supervisor : "";
    updatedFormData["prong2TimeHours"] =
      prong2Data.length > 0 ? prong2Data[0]?.cycle_time_hours : "";

    updatedFormData["prog3StartDate"] = prong3Data
      ? prong3Data[0]?.cycle_start_time
        ? dayjs(prong3Data[0].cycle_start_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog3StartTime"] = prong3Data
      ? prong3Data[0]?.cycle_start_time
        ? dayjs(prong3Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["prog3EndDate"] = prong3Data
      ? prong3Data[0]?.cycle_end_time
        ? dayjs(prong3Data[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog3EndTime"] = prong3Data
      ? prong3Data[0]?.cycle_end_time
        ? dayjs(prong3Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["prog3Operator"] =
      prong3Data.length > 0 ? prong3Data[0]?.operator : "";
    updatedFormData["prong3Supervisor"] =
      prong3Data.length > 0 ? prong3Data[0]?.supervisor : "";
    updatedFormData["prong3TimeHours"] =
      prong3Data.length > 0 ? prong3Data[0]?.cycle_time_hours : "";

    updatedFormData["prog4StartDate"] = prong4Data
      ? prong4Data[0]?.cycle_start_time
        ? dayjs(prong4Data[0].cycle_start_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog4StartTime"] = prong4Data
      ? prong4Data[0]?.cycle_start_time
        ? dayjs(prong4Data[0].cycle_start_time).format("HH:mm:ss")
        : "--"
      : "--";

    updatedFormData["prog4EndDate"] = prong4Data
      ? prong4Data[0]?.cycle_end_time
        ? dayjs(prong4Data[0].cycle_end_time).format("YYYY-MM-DD")
        : "--"
      : "--";
    updatedFormData["prog4EndTime"] = prong4Data
      ? prong4Data[0]?.cycle_end_time
        ? dayjs(prong4Data[0].cycle_end_time).format("HH:mm:ss")
        : "--"
      : "--";
    updatedFormData["prog4Operator"] =
      prong4Data.length > 0 ? prong4Data[0]?.operator : "";
    updatedFormData["prong4Supervisor"] =
      prong4Data.length > 0 ? prong4Data[0]?.supervisor : "";

    updatedFormData["prong4TimeHours"] =
      prong4Data.length > 0 ? prong4Data[0]?.cycle_time_hours : "";

    updatedFormData["chlorinationReceipe"] = chlorinationData
      ? chlorinationData[0]?.recipe
      : "";
    updatedFormData["cuttingType"] = cuttingData
      ? cuttingData[0]?.set_length
      : "";
    updatedFormData["actualLength"] = cuttingData
      ? cuttingData[0]?.actual_length
      : "";
    console.log("ljkldfhgkfdjkgj");
    setFormData(updatedFormData);
  }, [
    mqttData,
    trackingMqttData,
    batchId,
    stationPopup,
    strippingData,
    tunnelOvenData,
    leachingData,
    staticLeachingData,
    washing1Data,
    tumbledrying1Data,
    prong1Data,
    autoClaveData,
    cuttingData,
    washing2Data,
    tumbledrying2Data,
    acConditioningData,
    hancoMachine,
    chlorinationData,
    extraAcConditioningData,
    prong2Data,
    prong3Data,
    prong4Data,
  ]);

  // const handleClick = (station) => {
  //     setSelectedStation(station);
  //     setFormData({});
  //     setOpen(true);
  // };

  useEffect(() => {
    const topicArray = allStationData.map((e) => e.mqtt_topic);

    setTopic(topicArray);
  }, [allStationData]);

  useEffect(() => {
    handlegetAllStation();
  }, []);
  const handlegetAllStation = async () => {
    try {
      const resp = await getAllStationTopics();
      if (resp.status == 200 || resp.status == 201) {
        setAllstationData(resp.data.payload);
      }
    } catch (error) {
      setAllstationData([]);
      console.log("handlesubmit", error);
    }
  };

  const [apiDataFetched, setApiDataFetched] = useState(false);
  // State to track which API has been fetched
  const [fetchedApiLabel, setFetchedApiLabel] = useState([]);

  useEffect(() => {
    const apiFunctions = {
      Leaching: handleGetLeaching,
      "Visual Inspection": getVisualInspection,
      "Electrical Test": getElectricTestDataAPI,
      "UID Printing": getUidDeails,
      "Tunnel Oven": handleGetTunnelOven,
      Stripping: handleGetStrippingData,
      "Static Leaching": handleGetStaticLeachingData,
      "Washing Machine 2": handleGetgetWashineMachine2Data,
      "Washing Machine 1": handleGetWashing1Data,
      "Tumble Drying 2": handleGetTumbleDrying2,
      "Tumble Drying 1": handleGetTumbleDrying1,
      "Prong Oven 4": handleGetProngOven4,
      "Prong Oven 3": handleGetProngOven3,
      "Prong Oven 2": handleGetProngOven2,
      "Prong Oven 1": handleGetProngOven,
      Autoclave: handleGetAutoClave,
      Cutting: handleGetCuttingData,
      "AC Conditioning": handleGetAcConditioningData,
      "Hanco Washing": handleGetHancoMachineData,
      Chlorination: handleGetChlorinationData,
      "Extra AC Conditioning": handleGetExtraConditionerData,
      "UltraSonic": handleUltrasonic,
    };

    if (
      selectedStation?.machineData &&
      apiFunctions[selectedStation.machineData] &&
      // !apiDataFetched &&
      !fetchedApiLabel.includes(selectedStation.machineData)
    ) {
      apiFunctions[selectedStation.machineData]();
      setApiDataFetched(true);
      setFetchedApiLabel((prev) => [...prev, selectedStation.machineData]); // Store label after fetching
    }
  }, [selectedStation, apiDataFetched, fetchedApiLabel]);

  const handleClick = (station) => {
    console.log("lsdfksdhnfjkdn", station);
    setStationPopup(station);
    if (station) {
      if (station.label === "Ultrasonic") {
        setOpen(false);
        setUltrasonicPopups(true);
        handleUltrasonic()
      } else if (station.label === "Dipping") {
        setOpen(false);
        setDippingPopup(true);
      } else if (station.label === "Visual Inspection") {
        if (UpdateButtonData == true) {
          setOpen(true);
          setSelectedStation(station);
          // getVisualInspection();
        } else {
          setIsVisualInspection(true);
        }
      } else if (station.label === "Electrical Test") {
        if (UpdateButtonData == true) {
          // getElectricTestDataAPI();
          setOpen(true);
          setSelectedStation(station);
        }
      } else if (station.label === "UID Printing") {
        if (UpdateButtonData == true) {
          setOpen(true);
          setSelectedStation(station);
          // getUidDeails();
        }
      } else if (station.label === "Final Visual Inspection") {
        // setFinalVisualInspectionPopup(true);
      } else if (station.label === "Box Packing") {
        // setElectricTestPopupTest(true);
      } else if (station.label === "Polybag Packing") {
        // setElectricTestPopupTest(true);
      } else if (station.label === "Pairing") {
        // setElectricTestPopupTest(true);
      } else if (station.label === "Printing") {
        // setElectricTestPopupTest(true);
      } else if (station.label === "Out Feed Visual Inspection") {
        navigate(`/feed-visual-inspection/${batchId}`);
      } else if (station.label === "Leaching") {
        // handleGetLeaching();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Tunnel Oven") {
        // handleGetTunnelOven();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Stripping") {
        // handleGetStrippingData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Static Leaching") {
        // handleGetStaticLeachingData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.machineData === "Washing Machine 2") {
        // handleGetgetWashineMachine2Data();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Washing") {
        // handleGetWashing1Data();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.machineData === "Tumble Drying 2") {
        // handleGetTumbleDrying2();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Tumble Drying") {
        // handleGetTumbleDrying1();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.machineData === "Prong Oven 4") {
        // handleGetProngOven4();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.machineData === "Prong Oven 3") {
        // handleGetProngOven3();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.machineData === "Prong Oven 2") {
        // handleGetProngOven2();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Prong Oven") {
        // handleGetProngOven();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Autoclave") {
        // handleGetAutoClave();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Cutting") {
        // handleGetCuttingData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "AC Conditioning") {
        // handleGetAcConditioningData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Hanco washing") {
        // handleGetHancoMachineData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Chlorination") {
        // handleGetChlorinationData();
        setOpen(true);
        setSelectedStation(station);
      } else if (station.label === "Extra AC Conditioning") {
        // handleGetExtraConditionerData();
        setOpen(true);
        setSelectedStation(station);
      }
    }
  };

  const handleSubmit = async () => {};

  // Handle Form Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleChangeDisable = (e) => {
    const { name, value } = e.target;
    console.log("hcbhfndcxhbjndsxhjdmx", name, value);
    setDisableFieldFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // ✅ Ensure it's an array before mapping

    setBatchIdData(value);
  };

  const handleUpdateWashing = async () => {
    const params = {
      wm_id: washing1Data ? washing1Data.map((e) => e.id) : [],
      water_level: disableFieldFormData.water_level,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateWM1StationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateWashing1 = async () => {
    const params = {
      wm_id: washing2Data ? washing2Data.map((e) => e.id) : [],
      water_level: disableFieldFormData.washing2WaterLevel,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateWM2StationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateHnacoMachine = async () => {
    const params = {
      wm_id: hancoMachine ? hancoMachine.map((e) => e.id) : [],
      water_level: disableFieldFormData.hanco_water_level,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateHancoWashingStationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateAcConditioner = async () => {
    const params = {
      ac_id: acConditioningData ? acConditioningData?.map((e) => e.id) : [],
      // bin_number: disableFieldFormData.acConditionerBinNo,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateAcConditionerStationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };
  const handleUpdateExtraAcConditioner = async () => {
    const params = {
      ac_id: extraAcConditioningData
        ? extraAcConditioningData?.map((e) => e.id)
        : [],
      // bin_number: disableFieldFormData.extraAcConditionerBinNo,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateExtraAcConditionerStationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateLeachingData = async () => {
    const params = {
      leaching_id: leachingData ? leachingData?.map((e) => e.id) : [],
      hot_leaching_conductivity: disableFieldFormData.HotLeachingConductivity,
      cold_leaching_conductivity: disableFieldFormData.ColdLeachingConductivity,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateLeachingDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateStaticLeachingData = async () => {
    const params = {
      bin_no: selectedBin,
      batch_ids:
        Array.isArray(selectedBatch) && selectedBatch.length > 0
          ? selectedBatch
          : Array.isArray(BatchData) && BatchData.length > 0
          ? BatchData
          : BatchData
          ? JSON.parse(BatchData)
          : selectBatch,

      conductivity: disableFieldFormData.staticLeachingConductivity,
      operator: localStorage.getItem("operatorNameData"),
    };

    if (isStation == true) {
      params.tray_qr_code = latestQRs?.stationQR?.data;
      params.station_qr_code = latestQRs?.trayQR?.data;
    } else {
      params.tray_qr_code = latestQRs?.trayQR?.data;
      params.station_qr_code = latestQRs?.stationQR?.data;
    }

    try {
      const resp = await updateStaticLeaching(params);
      if (resp.status === 200 || resp.status === 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const handleUpdateProngOven = async () => {
    const params = {
      trolley: selectTrolly,
      batch_ids:
        Array.isArray(selectTrollyBatch) && selectTrollyBatch.length > 0
          ? selectTrollyBatch
          : Array.isArray(BatchData)
          ? BatchData
          : BatchData
          ? JSON.parse(BatchData)
          : selectBatch,
    };

    if (isStation == true) {
      params.tray_qr_code = latestQRs?.stationQR?.data;
      params.station_qr_code = latestQRs?.trayQR?.data;
    } else {
      params.tray_qr_code = latestQRs?.trayQR?.data;
      params.station_qr_code = latestQRs?.stationQR?.data;
    }

    try {
      const resp = await updateProngOvenDetails(params);
      if (resp.status === 200 || resp.status === 201) {
        toast.success(resp.data.message);
        setOpen(false);
        handleStationTracking();
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const handleUpdateTunnelOven = async () => {
    const operatorValue = localStorage.getItem("operatorNameData");
    const params = {
      tunnel_oven_id: tunnelOvenData ? tunnelOvenData?.map((e) => e.id) : [],
      operator: operatorValue,
    };
    try {
      const resp = await updateTunnelOvenStationDetails(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateAutoClave = async () => {
    const operatorValue = localStorage.getItem("operatorNameData");
    const params = {
      autoclave_ids: autoClaveData ? autoClaveData?.map((e) => e.id) : [],
      operator: operatorValue,
    };
    try {
      const resp = await updateAutoclave(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };
  const handleUpdateTumbleDrying = async () => {
    const operatorValue = localStorage.getItem("operatorNameData");
    const params = {
      td_id:
        tumbledrying1Data.length > 0
          ? tumbledrying1Data?.map((e) => e.id)
          : tumbledrying2Data.length > 0
          ? tumbledrying2Data?.map((e) => e.id)
          : [],
      operator: operatorValue,
    };
    try {
      const resp = await updateAutoclave(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateStripping = async () => {
    const operatorValue = localStorage.getItem("operatorNameData");
    const params = {
      stripping_id: strippingData ? strippingData?.map((e) => e.id) : [],
      operator: operatorValue,
    };
    try {
      const resp = await updateAutoclave(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleUpdateCuttingData = async () => {
    const params = {
      cutting_ids: cuttingData ? cuttingData?.map((e) => e.id) : [],
      set_length: disableFieldFormData.cuttingType
        ? disableFieldFormData.cuttingType
        : formData.cuttingType,
      actual_length: disableFieldFormData.actualLength
        ? disableFieldFormData.actualLength
        : formData.actualLength,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateCutting(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };
  const handleUpdateChlorination = async () => {
    const params = {
      chlorination_ids: chlorinationData
        ? chlorinationData?.map((e) => e.id)
        : [],
      recipe: disableFieldFormData.chlorinationReceipe
        ? disableFieldFormData.chlorinationReceipe
        : formData.chlorinationReceipe,
      operator: localStorage.getItem("operatorNameData"),
    };
    try {
      const resp = await updateChlorination(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };
  // Close Dialog
  const handleClose = () => {
    setOpen(false);
    setUltrasonicPopups(false);
    setDisableFieldFormData({});
    hasHandledClick.current = true;
  };

  const handleUpdate = async () => {
    const productionLinePermission = userPermission.find(
      (permission) => permission.module === "Production Line"
    );

    if (
      !productionLinePermission?.is_editor ||
      !productionLinePermission?.is_viewer
    ) {
      toast.error("You don't have access");
      return;
    }
    if (selectedStation.machineData == "Washing Machine 2") {
      handleUpdateWashing1();
    } else if (selectedStation.label == "Washing") {
      handleUpdateWashing();
    } else if (selectedStation.label == "AC Conditioning") {
      handleUpdateAcConditioner();
    } else if (selectedStation.label == "Hanco washing") {
      handleUpdateHnacoMachine();
    } else if (selectedStation.label == "Extra AC Conditioning") {
      handleUpdateExtraAcConditioner();
    } else if (selectedStation.label == "Leaching") {
      handleUpdateLeachingData();
    } else if (selectedStation.label == "Static Leaching") {
      handleUpdateStaticLeachingData();
    } else if (selectedStation.label == "Cutting") {
      handleUpdateCuttingData();
    } else if (selectedStation.label == "Autoclave") {
      handleUpdateAutoClave();
    } else if (selectedStation.label == "Tumble Drying") {
      handleUpdateTumbleDrying();
    } else if (selectedStation.label == "Stripping") {
      handleUpdateStripping();
    } else if (selectedStation.label == "Chlorination") {
      handleUpdateChlorination();
    } else if (selectedStation.label == "Prong Oven") {
      handleUpdateProngOven();
    } else if (selectedStation.label == "Tunnel Oven") {
      handleUpdateTunnelOven();
    } else {
      setOpen(false);
    }
  };

  const handleScanData = (field) => {
    console.log("esdfmskldfmsd", selectedBatch);
    const fieldData = field?.fields.filter((e) => e.label === "Operator Name");
    const supervisorData = field?.fields.filter(
      (e) => e.label === "Supervisor"
    );
    const operatorNameData = localStorage.getItem("operatorNameData");

    navigate(`/production-line`, {
      state: {
        batch_types: batchIdData,
        scanStation: true,
        operator_name: operatorNameData,
        // supervisor_name: formData[supervisorData[0].name],
        batchId: selectedBatch ? selectedBatch : selectTrollyBatch,
      },
    });
  };
  // useEffect(() => {
  //   handleGetLeaching();
  // }, []);

  // console.log(
  //   "hcbhfn",
  //   formData.strippingOperator,
  //   disableFieldFormData.strippingOperator
  // );
  const handleGetLeaching = async () => {
    try {
      const resp = await getLeachingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setLeachingData(resp.data.payload);
      }
    } catch (error) {
      setLeachingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetTunnelOven = async () => {
    try {
      const resp = await getTunnelOvenStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTunnelOvenData(resp.data.payload);
      }
    } catch (error) {
      setLeachingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetStrippingData = async () => {
    try {
      const resp = await getStrippingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setStrippingData(resp.data.payload);
      }
    } catch (error) {
      setStrippingData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetStaticLeachingData = async () => {
    try {
      const resp = await getStaticLeachingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setStaticLeachingData(resp.data.payload);
        setStaticBinData(resp.data.static_leaching_bins);
      }
    } catch (error) {
      setStaticLeachingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetWashing1Data = async () => {
    try {
      const resp = await getWashineMachine1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setWashing1Data(resp.data.payload);
      }
    } catch (error) {
      setWashing1Data([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetTumbleDrying1 = async () => {
    try {
      const resp = await getTumbleDrying1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDrying1Data(resp.data.payload);
      }
    } catch (error) {
      setTumbleDrying1Data([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetProngOven = async () => {
    try {
      const resp = await getProngOven1StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProng1Data(resp.data.payload);
        setTrollyData(resp.data.prong_oven_trolleys);
      }
    } catch (error) {
      setProng1Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven2 = async () => {
    try {
      const resp = await getProngOven2StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProng2Data(resp.data.payload);
        setTrollyData(resp.data.prong_oven_trolleys);
      }
    } catch (error) {
      setProng2Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven3 = async () => {
    try {
      const resp = await getProngOven3StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProng3Data(resp.data.payload);
        setTrollyData(resp.data.prong_oven_trolleys);
      }
    } catch (error) {
      setProng3Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetProngOven4 = async () => {
    try {
      const resp = await getProngOven4StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setProng4Data(resp.data.payload);
        setTrollyData(resp.data.prong_oven_trolleys);
      }
    } catch (error) {
      setProng4Data([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetAutoClave = async () => {
    try {
      const resp = await getAutoclaveStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setAutoClaveData(resp.data.payload);
      }
    } catch (error) {
      setAutoClaveData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetCuttingData = async () => {
    try {
      const resp = await getCuttingStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setCuttingData(resp.data.payload);
      }
    } catch (error) {
      setCuttingData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetgetWashineMachine2Data = async () => {
    try {
      const resp = await getWashineMachine2StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setWashing2Data(resp.data.payload);
      }
    } catch (error) {
      setWashing2Data([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetTumbleDrying2 = async () => {
    try {
      const resp = await getTumbleDrying2StationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setTumbleDrying2Data(resp.data.payload);
      }
    } catch (error) {
      setTumbleDrying2Data([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetAcConditioningData = async () => {
    try {
      const resp = await getAcConditioningStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setAcConditioningData(resp.data.payload);
      }
    } catch (error) {
      setAcConditioningData([]);
      console.log("handlesubmit", error);
    }
  };

  const handleGetHancoMachineData = async () => {
    try {
      const resp = await getHancoMachineStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setHancoMachine(resp.data.payload);
      }
    } catch (error) {
      setHancoMachine([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetChlorinationData = async () => {
    try {
      const resp = await getChlorinationStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setChlorinationData(resp.data.payload);
      }
    } catch (error) {
      setChlorinationData([]);
      console.log("handlesubmit", error);
    }
  };
  const handleGetExtraConditionerData = async () => {
    try {
      const resp = await getExtraAcConditionerStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setExtraAcConditioningData(resp.data.payload);
      }
    } catch (error) {
      setExtraAcConditioningData([]);
      console.log("handlesubmit", error);
    }
  };

  // const getPreviousStation = (data) => {
  //     let previousStation = null;
  //     for (let station of data) {
  //         if (station.status === 'processing') {
  //             return previousStation ? previousStation.station_name : null;
  //         }
  //         previousStation = station;
  //     }
  //     return null;
  // };

  // // Get the previous station name
  // const previousStationName = getPreviousStation(trackingData);
  // console.log("previousStationName:", previousStationName);

  // let prongOvenNumber = stationName?.match(/\d+/)?.[0]; // Extract oven number
  // console.log("stationName:", stationName);

  // let tagValue = `PRO_${prongOvenNumber}_ACT_TEMP`;
  // let tagValue1 = "WASHING_TEMP";
  // let tagValue2 = "WASHING_MC_2_TEMP";

  // let apiCallFunctions = []; // Store all functions to call
  // let tagValuesToPass = []; // Store tags to pass in API calls

  // switch (prevName || previousStationName) {
  //     case "Tumble Drying 1":
  //     case "Extra AC Conditioning":
  //     case "Final Visual Inspection":
  //         if (prongOvenNumber) {
  //             apiCallFunctions.push(apiFunctions[`Prong Oven ${prongOvenNumber}`]);
  //             tagValuesToPass.push(tagValue);
  //         }
  //         break;

  //     case "Static Leaching":
  //         apiCallFunctions.push(apiFunctions["Washing Machine 1"]);
  //         tagValuesToPass.push(tagValue1);
  //         break;

  //     case "Cutting":
  //         apiCallFunctions.push(apiFunctions["Washing Machine 2"]);
  //         tagValuesToPass.push(tagValue2);
  //         break;

  //     default:
  //         break;
  // }

  // // Call all collected API functions with tag values
  // apiCallFunctions.forEach((func, index) => {
  //     if (func) {
  //         func(tagValuesToPass[index]); // Pass corresponding tag value
  //     }
  // });
  const [processData, setProcessSteps] = useState([]);

  useEffect(() => {
    const updatedProcessSteps = processSteps.map((step) => {
      if (step.fields) {
        step.fields = step.fields.map((field) => {
          const tagValue = mergedTrackingArray.find(
            (f) => f.device_tag === field.deviceTag
          )?.tagValue;

          return {
            ...field,
            value: tagValue ?? field.value,
          };
        });
      }
      return step;
    });

    setProcessSteps(updatedProcessSteps);
  }, [trackingMqttData]);

  useEffect(() => {
    const updatedFields = matchData?.fields?.map((field) => {
      const tagValue = mergedTrackingArray.find(
        (f) => f.device_tag === field.deviceTag
      )?.tagValue;

      return {
        ...field,
        value: tagValue ?? field.value, // Update value if tagValue exists
      };
    });

    setMatchedData((prev) => ({
      ...prev,
      fields: updatedFields,
    }));
  }, [trackingMqttData, processData]);

  const getDeviceTag = (station) => {
    const machineName = trackingData.find((e) => e.station_name === station)
      ?.scanned_machine?.machine_name;
    return machineName ? `PRO_${machineName.split(" ")[2]}_ACT_TEMP` : "";
  };

  const processSteps = [
    {
      x: 50,
      y: 110,
      image: ProductionLineImages.tumbleOven,
      label: "Ultrasonic",
      DeviceMatch: "Ultrasonic",
      machineData: "Ultrasonic",
    },
    {
      x: 150,
      y: 110,
      image: ProductionLineImages.dipping,
      label: "Dipping",
      DeviceMatch: "Dipping",
      machineData: "Dipping",
    },
    {
      x: 300,
      y: 110,
      image: ProductionLineImages.outFeed,
      label: "Out Feed Visual Inspection",
      machineData: "Out Feed Visual Inspection",
      DeviceMatch: "Out Feed Visual Inspection",
      // fields: [
      //   { name: "max_temp", label: "Max Temp (°C)" },
      //   { name: "min_temp", label: "Min Temp (°C)" },
      // ],
    },
    {
      x: 440,
      y: 110,
      image: ProductionLineImages.leaching,
      label: "Leaching",
      machineData: "Leaching",
      DeviceMatch: "Leaching",
      fields: [
        // {
        //   name: "leaching_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: leachingData
        //     ? leachingData.map((e) => e.batch_type).join(",")
        //     : "",
        // },

        {
          name: "leachingBatch",
          label: "Batch No",
          type: "leachingBatch",
          value: formData.leachingBatch,
          batchNumber: localStorage.getItem("batch_type")
            ? JSON.parse(localStorage.getItem("batch_type"))
            : null,
        },
        {
          name: "HotLeachingStartTime",
          label: "Cycle Start Time (Hot Leaching)",
          disabled: true,
          value: leachingData
            ? leachingData[0]?.hot_leach_cycle_start_time
              ? dayjs(leachingData[0].hot_leach_cycle_start_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
        },
        {
          name: "Hot Leaching Set temp",
          label: "Hot Leaching Set temp",
          disabled: true,
          value:
            mergedArray.find((e) => e.device_tag == "HOT_LECH_T_SET_TEMP")?.[
              "tagValue"
            ] || "",
          deviceTag: "HOT_LECH_T_SET_TEMP",
        },
        {
          name: "Hot Leaching Act temp",
          label: "Hot Leaching Act temp",
          disabled: true,
          value:
            mergedArray.find((e) => e.device_tag == "HOT_LECH_T_ACT_TEMP")?.[
              "tagValue"
            ] || "",
          deviceTag: "HOT_LECH_T_ACT_TEMP",
        },
        {
          name: "Hot Leaching Water level",
          label: "Hot Leaching Water level",
          disabled: true,
          value:
            mergedArray.find((e) => e.device_tag == "HOT_LECH_T_WATER_LEVAL")?.[
              "tagValue"
            ] || "",
          deviceTag: "HOT_LECH_T_WATER_LEVAL",
        },
        {
          name: "HotLeachingConductivity",
          label: "Hot Leaching Conductivity",
          value: disableFieldFormData.HotLeachingConductivity,
        },
        {
          name: "HotLeachingEndTime",
          label: "Cycle End Time (Hot Leaching)",
          disabled: true,
          value: leachingData
            ? leachingData[0]?.hot_leach_cycle_end_time
              ? dayjs(leachingData[0].hot_leach_cycle_end_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
        },
        {
          name: "ColdLeachingStartTime",
          label: "Cycle Start Time (Cold Leaching)",
          disabled: true,
          value: leachingData
            ? leachingData[0]?.cold_leach_cycle_start_time
              ? dayjs(leachingData[0].cold_leach_cycle_start_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
        },

        {
          name: "Cold Leaching Water Level",
          label: "Cold Leaching Water Level",
          disabled: true,
          value:
            mergedArray.find(
              (e) => e.device_tag == "COLD_LECH_T_WATER_LEVAL"
            )?.["tagValue"] || "",
          deviceTag: "COLD_LECH_T_WATER_LEVAL",
        },
        {
          name: "ColdLeachingConductivity",
          label: "Cold Leaching Conductivity",
          value: disableFieldFormData.ColdLeachingConductivity,
        },
        {
          name: "ColdLeachingEndTime",
          label: "Cycle End Time (Cold Leaching)",
          disabled: true,
          value: leachingData
            ? leachingData[0]?.cold_leach_cycle_end_time
              ? dayjs(leachingData[0].cold_leach_cycle_end_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
        },

        {
          name: "leachingOperator",
          label: "Operator",
          type: "multiselectOperator",
          value: formData.leachingOperator,
          options: operatorListData,
          apiResponse: leachingData,
        },
      ],
    },
    {
      x: 550,
      y: 110,
      image: ProductionLineImages.tumbleOven,
      label: "Tunnel Oven",
      machineData: "Tunnel Oven",
      DeviceMatch: "Tunnel Oven",
      fields: [
        {
          name: "temp_zone_wise",
          label: "Tunnel Oven actual temperture zone wise",
          zone: "1",
          zone: "2",
          zone: "3",
          zone: "4",
          zone: "5",
          zone: "6",
          zone: "7",
          zone: "8",
        },
        // {
        //   name: "tunnelOvenData_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: tunnelOvenData
        //     ? tunnelOvenData.map((e) => e.batch_type).join(",")
        //     : "",
        // },

        {
          name: "tunnelOvenBatch",
          label: "Batch No",
          type: "tunnelOvenBatch",
          value: formData.tunnelOvenBatch,
        },
        {
          name: "in_feed",
          label: "In Feed",
          disabled: true,
          value: tunnelOvenData
            ? tunnelOvenData[0]?.in_feed
              ? dayjs(tunnelOvenData[0].in_feed).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "out_feed",
          label: "Out Feed",
          disabled: true,
          value: tunnelOvenData
            ? tunnelOvenData[0]?.out_feed
              ? dayjs(tunnelOvenData[0]?.out_feed).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "tunnelOvenStartTime",
          label: "Cycle Start Time",
          disabled: true,
          value: tunnelOvenData
            ? tunnelOvenData[0]?.cycle_start_time
              ? dayjs(tunnelOvenData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "tunnelOvenEndTime",
          label: "Cycle End Time",
          disabled: true,
          value: tunnelOvenData
            ? tunnelOvenData[0]?.cycle_end_time
              ? dayjs(tunnelOvenData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "tunnelOvenOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.tunnelOvenOperator,
          options: operatorListData,
          apiResponse: tunnelOvenData,
        },
      ],
    },
    {
      x: 670,
      y: 110,
      image: ProductionLineImages.stripping,
      label: "Stripping",
      machineData: "Stripping",
      DeviceMatch: "Stripping",
      fields: [
        {
          name: "strippingStartTime",
          label: "Start Time",
          disabled: true,
          value: strippingData
            ? strippingData[0]?.cycle_start_time
              ? dayjs(strippingData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "strippingEndTime",
          label: "End Time",
          disabled: true,
          value: strippingData
            ? strippingData[0]?.cycle_end_time
              ? dayjs(strippingData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "batch_no",
          label: "Batch No",
          type: "batch_no",
          value: formData.batch_no,
        },
        // {
        //   name: "batch_no",
        //   label: "Batch No.",
        //   disabled: true,
        //   value: strippingData
        //     ? strippingData.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "class",
          label: "Class",
          disabled: true,
          value: strippingData
            ? strippingData?.map((e) => e.class_name).join(",")
            : "",
        },
        {
          name: "size",
          label: "Size",
          disabled: true,
          value: strippingData
            ? strippingData?.map((e) => e.size_name).join(",")
            : "",
        },
        // {
        //   name: "operator",
        //   label: "Operator",
        //   disabled: true,
        //   value: strippingData ? strippingData[0]?.operator : "",
        // },
        {
          name: "strippingOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.strippingOperator,
          options: operatorListData,
          apiResponse: strippingData,
        },
        // {
        //   name: "supervisor",
        //   label: "Supervisor",
        //   disabled: true,
        //   value: strippingData ? strippingData[0]?.supervisor : "",
        // },
      ],
    },

    {
      x: 800,
      y: 110,
      image: ProductionLineImages.printing,
      label: "UID Printing",
      DeviceMatch: "UID Printing",
      machineData: "UID Printing",
      fields: [
        {
          name: "uidPrintingBatchNo",
          label: "Batch No",
          type: "uidPrintingBatchNo",
          value: formData.uidPrintingBatchNo,
          options: uidPrintingData,
        },
        {
          name: "uidPrintingOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.uidPrintingOperator,
          options: operatorListData,
          apiResponse: uidPrintingData,
        },
      ],
    },
    {
      x: 940,
      y: 110,
      image: ProductionLineImages.outFeed,
      label: "Visual Inspection",
      DeviceMatch: "Visual Inspection",
      machineData: "Visual Inspection",
      fields: [
        {
          name: "visualInspectionBatchNo",
          label: "Batch No",
          type: "visualInspectionBatchNo",
          value: visualInspectionData,
        },
        {
          name: "visualInspectionOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.visualInspectionOperator,
          options: operatorListData,
          apiResponse: visualInspectionData,
        },
      ],
    },
    {
      x: 1070,
      y: 110,
      image: ProductionLineImages.leaching,
      label: "Static Leaching",
      machineData: "Static Leaching",
      DeviceMatch: "Static Leaching",
      fields: [
        {
          name: "staticLeachingStartTime",
          label: "Cycle Start Time",
          value: staticLeachingData
            ? staticLeachingData[0]?.cycle_start_time
              ? dayjs(staticLeachingData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "staticLeachingConductivity",
          label: "Conductivity",
          value: disableFieldFormData.staticLeachingConductivity,
        },
        {
          name: "staticLeachingEndTime",
          label: "Cycle End Time",
          disabled: true,
          value: staticLeachingData
            ? staticLeachingData[0]?.cycle_end_time
              ? dayjs(staticLeachingData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "staticLeachingOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.staticLeachingOperator,
          options: operatorListData,
          apiResponse: staticLeachingData,
        },
      ],
    },
    {
      x: 170,
      y: 260,
      image: ProductionLineImages.tumbleDry,
      label: "Tumble Drying",

      DeviceMatch: "Tumble Drying",
      machineData: "Tumble Drying 2",
      fields: [
        {
          name: "tumbleDryingBatch",
          label: "Batch No",
          type: "tumbleDryingBatch",
          value: formData.tumbleDryingBatch,
        },
        // {
        //   name: "tumbleDryingBatch",
        //   label: "Batch No",
        //   disabled: true,
        //   value: tumbledrying2Data
        //     ? tumbledrying2Data.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "temp",
          label: "Temp (°C)",
          value:
            mergedArray.find((e) => e.device_tag == "DRYER_TEMP")?.[
              "tagValue"
            ] || "",
          disabled: true,

          deviceTag: "DRYER_TEMP",
        },
        {
          name: "tumble2Time",
          label: "Time (minutes)",
          disabled: true,
          value: tumbledrying2Data ? tumbledrying2Data[0]?.time_minutes : "",
        },
        {
          name: "tumble2StartTime",
          label: "Cycle Start Time",
          value: tumbledrying2Data
            ? tumbledrying2Data[0]?.cycle_start_time
              ? dayjs(tumbledrying2Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "tumble2EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: tumbledrying2Data
            ? tumbledrying2Data[0]?.cycle_end_time
              ? dayjs(tumbledrying2Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "tumble2Operator",
        //   label: "Operator",
        //   value: tumbledrying2Data ? tumbledrying2Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "tumble2Operator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.tumble2Operator,
          options: operatorListData,
          apiResponse: tumbledrying2Data,
        },
        // {
        //   name: "tumble2Supervisor",
        //   label: "Supervisor",
        //   disabled: true,
        //   value: tumbledrying2Data ? tumbledrying2Data[0]?.supervisor : "",
        // },
      ],
    },
    {
      x: 320,
      y: 260,
      image: ProductionLineImages.washing,
      label: "Washing",
      DeviceMatch: "Washing",
      machineData: "Washing Machine 2",
      fields: [
        {
          name: "washing2_batch_no",
          label: "Batch No",
          type: "washing2_batch_no",
          value: formData.washing2_batch_no,
        },
        // {
        //   name: "washing2_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: washing2Data
        //     ? washing2Data.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "max_temp",
          label: "Act Temp (°C)",
          // value:
          //   mergedArray.find((e) => e.device_tag == washing1)?.["tagValue"] ||
          //   "",
          // disabled: true,
          // deviceTag: washing1,
          value: (() => {
            const machineName = trackingData.find(
              (e) => e.station_name === "Washing Machine 2"
            )?.scanned_machine?.machine_name;
            let deviceTag = "";

            if (machineName === "Washing Machine 1") {
              deviceTag = "WASHING_TEMP";
            } else if (machineName === "Washing Machine 2") {
              deviceTag = "WASHING_MC_2_TEMP";
            }

            // Check mergedTrackingArray first
            const trackingEntry = mergedTrackingArray.find(
              (e) => e.device_tag === deviceTag
            );
            if (trackingEntry) {
              return trackingEntry.tagValue || "";
            }

            // Fallback to mergedArray
            return (
              mergedArray.find((e) => e.device_tag === deviceTag)?.tagValue ||
              ""
            );
          })(),
          deviceTag:
            trackingData.find((e) => e.station_name === "Washing Machine 2")
              ?.scanned_machine?.machine_name === "Washing Machine 1"
              ? "WASHING_TEMP"
              : trackingData.find((e) => e.station_name === "Washing Machine 2")
                  ?.scanned_machine?.machine_name === "Washing Machine 2"
              ? "WASHING_MC_2_TEMP"
              : "",
          // deviceTag:
          //   mergedTrackingArray.find(
          //     (e) =>
          //       e.device_tag === "WASHING_TEMP" ||
          //       e.device_tag === "WASHING_MC_2_TEMP"
          //   )?.device_tag || "",
          disabled: true,
        },
        // {
        //   name: "min_temp",
        //   label: "Min Temp(°C)",
        //   value:
        //     mergedArray.find((e) => e.device_tag == "WASHING_MC_2_TEMP")?.[
        //       "tagValue"
        //     ] || "",

        //   disabled: true,
        //   machineData: "Washing",
        //   deviceTag: "WASHING_MC_2_TEMP",
        // },
        {
          name: "washing2TimeMinutes",
          label: "Time Minutes",
          value: washing2Data ? washing2Data[0]?.time_minutes : "",
          disabled: true,
        },
        {
          name: "washing2WaterLevel",
          label: "Water Level (Litres)",
          value: disableFieldFormData.washing2WaterLevel,
        },
        {
          name: "washing2Quantity",
          label: "Quantity (Nos)",

          value: washing2Data
            ? washing2Data.reduce(
                (sum, item) => sum + (Number(item.quantity) || 0),
                0
              )
            : 0,

          disabled: true,
        },
        {
          name: "washing2StartTime",
          label: "Cycle Start Time",
          value: washing2Data
            ? washing2Data[0]?.cycle_start_time
              ? dayjs(washing2Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "Washing2EndTime",
          label: "Cycle End Time",
          value: washing2Data
            ? washing2Data[0]?.cycle_end_time
              ? dayjs(washing2Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "washing2Operator",
        //   label: "Operator",
        //   value: washing2Data ? washing2Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "washing2Operator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.washing2Operator,
          options: operatorListData,
          apiResponse: washing2Data,
        },
        // {
        //   name: "washing2Supervisor",
        //   label: "Supervisor",
        //   disabled: true,
        //   value: washing2Data ? washing2Data[0]?.supervisor : "",
        // },
      ],
    },
    {
      x: 470,
      y: 260,
      image: ProductionLineImages.cutting,
      label: "Cutting",
      machineData: "Cutting",
      DeviceMatch: "Cutting",
      fields: [
        {
          name: "cutting_batch_no",
          label: "Batch No",
          type: "cutting_batch_no",
          value: formData.cutting_batch_no,
        },

        {
          name: "cuttingType",
          label: "Set Length",
          type: "dropdown",
          options: ["280mm", "360mm", "410mm"],
          value: formData.cuttingType,
        },
        {
          name: "actualLength",
          label: "Actual Length",
          value: formData.actualLength,
        },
        {
          name: "cuttingStartTime",
          label: "Cycle Start Time",
          value: cuttingData
            ? cuttingData[0]?.cycle_start_time
              ? dayjs(cuttingData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : " ",
          disabled: true,
        },
        {
          name: "cuttingEndTime",
          label: "Cycle End Time",
          disabled: true,
          value: cuttingData
            ? cuttingData[0]?.cycle_end_time
              ? dayjs(cuttingData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : " ",
        },
        {
          name: "cuttingOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.cuttingOperator,
          options: operatorListData,
          apiResponse: cuttingData,
        },
      ],
    },
    {
      x: 620,
      y: 260,
      image: ProductionLineImages.autoClave,
      DeviceMatch: "Autoclave",
      machineData: "Autoclave",
      label: "Autoclave",

      fields: [
        {
          name: "autoClave_batch_no",
          label: "Batch No",
          type: "autoClave_batch_no",
          value: formData.autoClave_batch_no,
        },
        {
          name: "pressure",
          label: "Pressure (bar)",
          value:
            mergedArray.find((e) => e.device_tag == "AUTCLV_ACT_P")?.[
              "tagValue"
            ] || "",
          deviceTag: "AUTCLV_ACT_P",
          // value: mqttData.find((e) => e.AUTCLV_ACT_P)?.AUTCLV_ACT_P || "",
          disabled: true,
        },
        {
          name: "max_temp",
          label: "Max Temp (°C)",
          value:
            mergedArray.find((e) => e.device_tag == "AUTCLV_ACT_TEMP")?.[
              "tagValue"
            ] || "",
          deviceTag: "AUTCLV_ACT_TEMP",
          // value: mqttData.find((e) => e.AUTCLV_ACT_TEMP)?.AUTCLV_ACT_TEMP || "",
          disabled: true,
        },
        {
          name: "autoClaveTimeMinutes",
          label: "Time Minutes",
          disabled: true,
          value: autoClaveData ? autoClaveData[0]?.cycle_time_minutes : "",
        },
        {
          name: "autoClaveStartTime",
          label: "Cycle Start Time",
          value: autoClaveData
            ? autoClaveData[0]?.cycle_start_time
              ? dayjs(autoClaveData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "autoClaveEndTime",
          label: "Cycle End Time",
          value: autoClaveData
            ? autoClaveData[0]?.cycle_end_time
              ? dayjs(autoClaveData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "autoClaveOperator",
        //   label: "Operator",
        //   value: autoClaveData ? autoClaveData[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "autoClaveOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.autoClaveOperator,
          options: operatorListData,
          apiResponse: autoClaveData,
        },
        // {
        //   name: "autoClaveSupervisor",
        //   label: "Supervisor",
        //   disabled: true,
        //   value: autoClaveData ? autoClaveData[0]?.supervisor : "",
        // },
      ],
    },
    {
      x: 770,
      y: 260,
      image: ProductionLineImages.prongOven,
      label: "Prong Oven",
      DeviceMatch: "Prong Oven",
      machineData: "Prong Oven 1",
      fields: [
        // {
        //   name: "prong1_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: prong1Data
        //     ? prong1Data.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "temp",
          label: "Temp (°C)",
          // value: getTemperatureValue("Prong Oven 1"),
          value: mergedTrackingArray
            ? mergedTrackingArray.find(
                (e) =>
                  e.device_tag === "PRO_1_ACT_TEMP" ||
                  e.device_tag === "PRO_2_ACT_TEMP" ||
                  e.device_tag === "PRO_3_ACT_TEMP" ||
                  e.device_tag === "PRO_4_ACT_TEMP" ||
                  e.device_tag === "PRO_5_ACT_TEMP" ||
                  e.device_tag === "PRO_6_ACT_TEMP" ||
                  e.device_tag === "PRO_7_ACT_TEMP" ||
                  e.device_tag === "PRO_8_ACT_TEMP" ||
                  e.device_tag === "BIG_ACT_TEMP"
              )?.tagValue || ""
            : "",
          // deviceTag: getDeviceTag("Prong Oven 1"),
          // deviceTag:
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 1" ? "PRO_1_ACT_TEMP" :
          //  trackingData.find( (e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 2" ? "PRO_2_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 3" ? "PRO_3_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 4" ? "PRO_4_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 5" ? "PRO_5_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 6" ? "PRO_6_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 7" ? "PRO_7_ACT_TEMP" :
          // trackingData.find((e) => e.station_name === "Prong Oven 1")?.scanned_machine?.machine_name === "Prong Oven 8" ? "PRO_8_ACT_TEMP" :
          // "",
          deviceTag:
            mergedTrackingArray.find(
              (e) =>
                e.device_tag === "PRO_1_ACT_TEMP" ||
                e.device_tag === "PRO_2_ACT_TEMP" ||
                e.device_tag === "PRO_3_ACT_TEMP" ||
                e.device_tag === "PRO_4_ACT_TEMP" ||
                e.device_tag === "PRO_5_ACT_TEMP" ||
                e.device_tag === "PRO_6_ACT_TEMP" ||
                e.device_tag === "PRO_7_ACT_TEMP" ||
                e.device_tag === "PRO_8_ACT_TEMP" ||
                e.device_tag === "BIG_ACT_TEMP"
            )?.device_tag || "",

          // value: mqttData.find((e) => e.PRO_1_ACT_TEMP)?.PRO_1_ACT_TEMP || "",
          disabled: true,
        },
        // {
        //   name: "prog1TimeHours",
        //   label: "Total Cycle (Hr)",
        //   disabled: true,
        //   value: prong1Data ? prong1Data[0]?.cycle_time_hours : "",
        // },
        {
          name: "prog1StartDate",
          label: "Cycle Start Date",
          value: prong1Data
            ? prong1Data[0]?.cycle_start_time
              ? dayjs(prong1Data[0].cycle_start_time).format("YYYY-MM-DD")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "prog1StartTime",
          label: "Cycle Start Time",
          value: prong1Data
            ? prong1Data[0]?.cycle_start_time
              ? dayjs(prong1Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "prog1Operator",
        //   label: "Operator Name",
        //   type: "prog1Operator",
        //   value: formData.prog1Operator,
        // },
        {
          name: "prog1StartOperator",
          label: "Cycle Start Operator Name",
          type: "multiselectOperator",
          value: formData.prog1StartOperator,
          options: operatorListData,
          apiResponse: prong1Data,
        },
        {
          name: "prog1EndDate",
          label: "Cycle End Date",
          disabled: true,
          value: prong1Data
            ? prong1Data[0]?.cycle_end_time
              ? dayjs(prong1Data[0].cycle_end_time).format("YYYY-MM-DD")
              : "--"
            : "--",
        },
        {
          name: "prog1EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: prong1Data
            ? prong1Data[0]?.cycle_end_time
              ? dayjs(prong1Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        {
          name: "prog1EndOperator",
          label: "Cycle End Operator Name",
          type: "multiselectOperator",
          value: formData.prog1EndOperator,
          options: operatorListData,
          apiResponse: prong1Data,
        },
      ],
    },
    {
      x: 920,
      y: 260,
      image: ProductionLineImages.tumbleDry,
      label: "Tumble Drying",
      DeviceMatch: "Tumble Drying",
      machineData: "Tumble Drying 1",
      fields: [
        {
          name: "tumbledrying1_batch_no",
          label: "Batch No",
          type: "tumbledrying1_batch_no",
          value: formData.tumbledrying1_batch_no,
        },

        {
          name: "temp",
          label: "Temp (°C)",
          value:
            mergedArray.find((e) => e.device_tag == "DRYER_TEMP")?.[
              "tagValue"
            ] || "",
          disabled: true,

          deviceTag: "DRYER_TEMP",
        },
        {
          name: "TumbleTime",
          label: "Time (minutes)",
          disabled: true,
          value: tumbledrying1Data ? tumbledrying1Data[0]?.time_minutes : "",
        },
        {
          name: "tumbleDrying1startTime",
          label: "Cycle Start Time",
          value: tumbledrying1Data
            ? tumbledrying1Data[0]?.cycle_start_time
              ? dayjs(tumbledrying1Data.cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "tumbleDrying1EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: tumbledrying1Data
            ? tumbledrying1Data[0]?.cycle_end_time
              ? dayjs(tumbledrying1Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "TumbleOperator",
        //   label: "Operator",
        //   value: tumbledrying1Data ? tumbledrying1Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "TumbleOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.tumbleOperator,
          options: operatorListData,
          apiResponse: tumbledrying1Data,
        },
        // {
        //   name: "TumbleSupervisor",
        //   label: "Supervisor",
        //   disabled: true,
        //   value: tumbledrying1Data ? tumbledrying1Data[0]?.supervisor : "",
        // },
      ],
    },
    {
      x: 1050,
      y: 260,
      image: ProductionLineImages.washing,
      label: "Washing",
      DeviceMatch: "Washing",
      machineData: "Washing Machine 1",
      fields: [
        {
          name: "washing1_batch_no",
          label: "Batch No",
          type: "washing1_batch_no",
          value: formData.washing1_batch_no,
        },

        {
          name: "max_temp",
          label: "Act Temp (°C)",
          value: (() => {
            const machineName = trackingData.find(
              (e) => e.station_name === "Washing Machine 1"
            )?.scanned_machine?.machine_name;
            let deviceTag = "";

            if (machineName === "Washing Machine 1") {
              deviceTag = "WASHING_TEMP";
            } else if (machineName === "Washing Machine 2") {
              deviceTag = "WASHING_MC_2_TEMP";
            }

            // Check mergedTrackingArray first
            const trackingEntry = mergedTrackingArray.find(
              (e) => e.device_tag === deviceTag
            );
            if (trackingEntry) {
              return trackingEntry.tagValue || "";
            }

            // Fallback to mergedArray
            return (
              mergedArray.find((e) => e.device_tag === deviceTag)?.tagValue ||
              ""
            );
          })(),
          deviceTag:
            trackingData.find((e) => e.station_name === "Washing Machine 1")
              ?.scanned_machine?.machine_name === "Washing Machine 1"
              ? "WASHING_TEMP"
              : trackingData.find((e) => e.station_name === "Washing Machine 1")
                  ?.scanned_machine?.machine_name === "Washing Machine 2"
              ? "WASHING_MC_2_TEMP"
              : "",
          // deviceTag:
          //   mergedTrackingArray.find(
          //     (e) =>
          //       e.device_tag === "WASHING_TEMP" ||
          //       e.device_tag === "WASHING_MC_2_TEMP"
          //   )?.device_tag || "",
          disabled: true,
        },

        // {
        //   name: "min_temp",
        //   label: "Min Temp(°C)",
        //   value:
        //     mergedArray.find((e) => e.device_tag == "WASHING_TEMP")?.[
        //       "tagValue"
        //     ] || "",
        //   deviceTag: "WASHING_TEMP",
        //   // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
        //   disabled: true,
        // },
        {
          name: "time_minutes",
          label: "Time Minutes",
          value: washing1Data ? washing1Data[0]?.time_minutes : "",

          disabled: true,
        },
        {
          name: "water_level",
          label: "Water Level (Litres)",
          value: disableFieldFormData.water_level,
        },
        {
          name: "quantity",
          label: "Quantity (Nos)",
          value: washing1Data
            ? washing1Data.reduce(
                (sum, item) => sum + (Number(item.quantity) || 0),
                0
              )
            : 0,
          disabled: true,
        },
        {
          name: "washing1startTime",
          label: "Cycle Start Time",
          value: washing1Data
            ? washing1Data[0]?.cycle_start_time
              ? dayjs(washing1Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "washing1EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: washing1Data
            ? washing1Data[0]?.cycle_end_time
              ? dayjs(washing1Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "washingoperator",
        //   label: "Operator",
        //   value: washing1Data ? washing1Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "washingoperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.washingoperator,
          options: operatorListData,
          apiResponse: washing1Data,
        },
        // {
        //   name: "washingSupervisor",
        //   label: "Supervisor",
        //   value: washing1Data ? washing1Data[0]?.supervisor : "",
        //   disabled: true,
        // },
      ],
    },

    {
      x: 170,
      y: 410,
      image: ProductionLineImages.prongOven,
      label: "Prong Oven",
      DeviceMatch: "Prong Oven",
      machineData: "Prong Oven 2",
      fields: [
        {
          name: "temp",
          label: "Temp (°C)",
          // value: getTemperatureValue("Prong Oven 2"),
          value: mergedTrackingArray
            ? mergedTrackingArray.find(
                (e) =>
                  e.device_tag === "PRO_1_ACT_TEMP" ||
                  e.device_tag === "PRO_2_ACT_TEMP" ||
                  e.device_tag === "PRO_3_ACT_TEMP" ||
                  e.device_tag === "PRO_4_ACT_TEMP" ||
                  e.device_tag === "PRO_5_ACT_TEMP" ||
                  e.device_tag === "PRO_6_ACT_TEMP" ||
                  e.device_tag === "PRO_7_ACT_TEMP" ||
                  e.device_tag === "PRO_8_ACT_TEMP" ||
                  e.device_tag === "BIG_ACT_TEMP"
              )?.tagValue || ""
            : "",
          // deviceTag: getDeviceTag("Prong Oven 2"),
          deviceTag:
            mergedTrackingArray.find(
              (e) =>
                e.device_tag === "PRO_1_ACT_TEMP" ||
                e.device_tag === "PRO_2_ACT_TEMP" ||
                e.device_tag === "PRO_3_ACT_TEMP" ||
                e.device_tag === "PRO_4_ACT_TEMP" ||
                e.device_tag === "PRO_5_ACT_TEMP" ||
                e.device_tag === "PRO_6_ACT_TEMP" ||
                e.device_tag === "PRO_7_ACT_TEMP" ||
                e.device_tag === "PRO_8_ACT_TEMP" ||
                e.device_tag === "BIG_ACT_TEMP"
            )?.device_tag || "",
          disabled: true,
        },
        // {
        //   name: "prong2TimeHours",
        //   label: "Total Cycle (Hr)",
        //   disabled: true,
        //   value: prong2Data ? prong2Data[0]?.cycle_time_hours : "",
        // },
        {
          name: "prog2StartDate",
          label: "Cycle Start Date",
          value: prong2Data
            ? prong2Data[0]?.cycle_start_time
              ? dayjs(prong2Data[0].cycle_start_time).format("YYYY-MM-DD")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "prog2StartTime",
          label: "Cycle Start Time",
          value: prong2Data
            ? prong2Data[0]?.cycle_start_time
              ? dayjs(prong2Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "prog2StartOperator",
          label: "Cycle Start Operator Name",
          type: "multiselectOperator",
          value: formData.prog2StartOperator,
          options: operatorListData,
          apiResponse: prong2Data,
        },
        {
          name: "prog2EndDate",
          label: "Cycle End Date",
          disabled: true,
          value: prong2Data
            ? prong2Data[0]?.cycle_end_time
              ? dayjs(prong2Data[0].cycle_end_time).format("YYYY-MM-DD")
              : "--"
            : "--",
        },
        {
          name: "prog2EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: prong2Data
            ? prong2Data[0]?.cycle_end_time
              ? dayjs(prong2Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "prong2Supervisor",
        //   label: "Cycle End Operator Name",
        //   disabled: true,
        //   value: prong2Data ? prong2Data[0]?.supervisor : "",
        // },
        {
          name: "prog2EndOperator",
          label: "Cycle End Operator Name",
          type: "multiselectOperator",
          value: formData.prog2EndOperator,
          options: operatorListData,
          apiResponse: prong2Data,
        },
      ],
    },

    {
      x: 320,
      y: 410,
      image: ProductionLineImages.acConditing,
      label: "AC Conditioning",
      machineData: "AC Conditioning",
      DeviceMatch: "Extra AC Conditioning",
      fields: [
        {
          name: "ac_batch_no",
          label: "Batch No",
          type: "ac_batch_no",

          value: formData.ac_batch_no,
        },
        {
          name: "max_temp",
          label: "Act Temp (°C)",

          value:
            mergedArray.find((e) => e.device_tag == "AC_ROOM_1_TEMP")?.[
              "tagValue"
            ] || "",
          deviceTag: "AC_ROOM_1_TEMP",
          // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
          disabled: true,
        },
        {
          // name: "max_temp",
          name: "acConditionerRE",
          label: "RE/SC",

          value: acConditioningData
            ? acConditioningData.map((e) => e.sc_re).join(",")
            : "",
          disabled: true,
        },
        {
          name: "acConditionerBinNo",
          label: "BIN No",
          value: acConditioningData
            ? acConditioningData.map((e) => e.bin_number).join(",")
            : "",
          disabled: true,
          // value: disableFieldFormData.acConditionerBinNo,
          // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
        },
        {
          name: "acConditionerqty",
          label: "QTY",
          value: acConditioningData
            ? acConditioningData.reduce(
                (sum, item) => sum + (Number(item.quantity) || 0),
                0
              )
            : 0,
          disabled: true,
        },

        {
          name: "acConditionerStartDate",
          label: "START DATE",
          value: acConditioningData
            ? acConditioningData[0]?.cycle_start_time
              ? dayjs(acConditioningData[0].cycle_start_time).format(
                  "YYYY-MM-DD"
                )
              : "--"
            : "",
          disabled: true,
        },
        {
          name: "acConditionerStartTime",
          label: "START TIME",
          value: acConditioningData
            ? acConditioningData[0]?.cycle_start_time
              ? dayjs(acConditioningData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "",
          disabled: true,
        },
        {
          name: "acConditionerEndDate",
          label: "END DATE",
          value: acConditioningData
            ? acConditioningData[0]?.cycle_end_time
              ? dayjs(acConditioningData[0].cycle_end_time).format("YYYY-MM-DD")
              : "--"
            : "",
          disabled: true,
        },
        {
          name: "acConditionerEndTime",
          label: "END TIME",
          value: acConditioningData
            ? acConditioningData[0]?.cycle_end_time
              ? dayjs(acConditioningData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "",
          disabled: true,
        },
        // {
        //   name: "acConditionerOperator",
        //   label: "OPERATOR",
        //   value: acConditioningData ? acConditioningData[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "acConditionerOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.acConditionerOperator,
          options: operatorListData,
          apiResponse: acConditioningData,
        },
      ],
    },
    {
      x: 470,
      y: 410,
      image: ProductionLineImages.washing,
      label: "Hanco washing",
      machineData: "Hanco Washing",
      DeviceMatch: "Washing",
      fields: [
        {
          name: "hancoMachine_batch_no",
          label: "Batch No",
          type: "hancoMachine_batch_no",

          value: formData.hancoMachine_batch_no,
        },
        // {
        //   name: "hancoMachine_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: hancoMachine
        //     ? hancoMachine.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "max_temp",
          label: "Act Temp (°C)",
          value: (() => {
            const machineName = trackingData.find(
              (e) => e.station_name === "Hanco Washing"
            )?.scanned_machine?.machine_name;
            let deviceTag = "";
            if (machineName === "Washing Machine 1") {
              deviceTag = "WASHING_TEMP";
            } else if (machineName === "Washing Machine 2") {
              deviceTag = "WASHING_MC_2_TEMP";
            }

            // Check mergedTrackingArray first
            const trackingEntry = mergedTrackingArray.find(
              (e) => e.device_tag === deviceTag
            );
            if (trackingEntry) {
              return trackingEntry.tagValue || "";
            }

            // Fallback to mergedArray
            return (
              mergedArray.find((e) => e.device_tag === deviceTag)?.tagValue ||
              ""
            );
          })(),

          // value:
          //   mergedTrackingArray.find(
          //     (e) =>
          //       e.device_tag === "WASHING_TEMP" ||
          //       e.device_tag === "WASHING_MC_2_TEMP"
          //   )?.tagValue || "",
          deviceTag:
            trackingData.find((e) => e.station_name === "Hanco Washing")
              ?.scanned_machine?.machine_name === "Washing Machine 1"
              ? "WASHING_TEMP"
              : trackingData.find((e) => e.station_name === "Hanco Washing")
                  ?.scanned_machine?.machine_name === "Washing Machine 2"
              ? "WASHING_MC_2_TEMP"
              : "",
          // deviceTag:
          //   mergedTrackingArray.find(
          //     (e) =>
          //       e.device_tag === "WASHING_TEMP" ||
          //       e.device_tag === "WASHING_MC_2_TEMP"
          //   )?.device_tag || "",
          // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
          disabled: true,
        },
        // {
        //   name: "min_temp",
        //   label: "Min Temp(°C)",
        //   value:
        //     mergedArray.find((e) => e.device_tag == "WASHING_TEMP")?.[
        //       "tagValue"
        //     ] || "",
        //   deviceTag: "WASHING_TEMP",
        //   // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
        //   disabled: true,
        // },
        {
          name: "hanco_time_minutes",
          label: "Time Minutes",
          value: hancoMachine ? hancoMachine[0]?.time_minutes : "",
          disabled: true,
        },
        {
          name: "hanco_water_level",
          label: "Water Level (Litres)",
          value: disableFieldFormData.hanco_water_level,
        },
        {
          name: "hanco_quantity",
          label: "Quantity (Nos)",
          value: hancoMachine
            ? hancoMachine.reduce(
                (sum, item) => sum + (Number(item.quantity) || 0),
                0
              )
            : 0,
          disabled: true,
        },
        {
          name: "hanco_start_time",
          label: "Cycle Start Time",
          value: hancoMachine
            ? hancoMachine[0]?.cycle_start_time
              ? dayjs(hancoMachine[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "hanco_end_time",
          label: "Cycle End Time",
          value: hancoMachine
            ? hancoMachine[0]?.cycle_end_time
              ? dayjs(hancoMachine[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "hanco_operator",
        //   label: "Operator",
        //   value: hancoMachine ? hancoMachine[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "hanco_operator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.hanco_operator,
          options: operatorListData,
          apiResponse: hancoMachine,
        },
        // {
        //   name: "hanco_supervisor",
        //   label: "Supervisor",
        //   value: hancoMachine ? hancoMachine[0]?.supervisor : "",
        //   disabled: true,
        // },
      ],
    },
    {
      x: 620,
      y: 410,
      image: ProductionLineImages.chlorination,
      label: "Chlorination",
      machineData: "Chlorination",
      DeviceMatch: "Chlorination",
      fields: [
        {
          name: "chlorination_batch_no",
          label: "Batch No",
          type: "chlorination_batch_no",
          value: formData.chlorination_batch_no,
        },

        // {
        //   name: "chlorination_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: chlorinationData
        //     ? chlorinationData.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "chlorinationReceipe",
          label: "Receipe",
          type: "chlorinationDropdown",
          options: ["PREWASH", "Higher Class", "Lower Class"],
          value: formData.chlorinationReceipe,
        },
        {
          name: "chlorinationStartTime",
          label: "START TIME",
          value: chlorinationData
            ? chlorinationData[0]?.cycle_start_time
              ? dayjs(chlorinationData[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "chlorinationEndTime",
          label: "END TIME",
          value: chlorinationData
            ? chlorinationData[0]?.cycle_end_time
              ? dayjs(chlorinationData[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "EMERGENCY",
          label: "EMERGENCY",
          value:
            mergedArray.find((e) => e.device_tag == "EMERGENCY")?.[
              "tagValue"
            ] == 0
              ? "Normal"
              : mergedArray.find((e) => e.device_tag == "EMERGENCY")?.[
                  "tagValue"
                ] == 1
              ? "ALARM"
              : "",
          deviceTag: "EMERGENCY",
          disabled: true,
        },
        {
          name: "chlorinationOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.chlorinationOperator,
          options: operatorListData,
          apiResponse: chlorinationData,
        },
      ],
    },

    {
      x: 770,
      y: 410,
      image: ProductionLineImages.prongOven,
      label: "Prong Oven",
      DeviceMatch: "Prong Oven",
      machineData: "Prong Oven 3",
      fields: [
        // {
        //   name: "prong3_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: prong3Data
        //     ? prong3Data.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "temp",
          label: "Temp (°C)",
          // value: getTemperatureValue("Prong Oven 3"),
          value: mergedTrackingArray
            ? mergedTrackingArray.find(
                (e) =>
                  e.device_tag === "PRO_1_ACT_TEMP" ||
                  e.device_tag === "PRO_2_ACT_TEMP" ||
                  e.device_tag === "PRO_3_ACT_TEMP" ||
                  e.device_tag === "PRO_4_ACT_TEMP" ||
                  e.device_tag === "PRO_5_ACT_TEMP" ||
                  e.device_tag === "PRO_6_ACT_TEMP" ||
                  e.device_tag === "PRO_7_ACT_TEMP" ||
                  e.device_tag === "PRO_8_ACT_TEMP" ||
                  e.device_tag === "BIG_ACT_TEMP"
              )?.tagValue || ""
            : "",
          // deviceTag: getDeviceTag("Prong Oven 3"),
          deviceTag:
            mergedTrackingArray.find(
              (e) =>
                e.device_tag === "PRO_1_ACT_TEMP" ||
                e.device_tag === "PRO_2_ACT_TEMP" ||
                e.device_tag === "PRO_3_ACT_TEMP" ||
                e.device_tag === "PRO_4_ACT_TEMP" ||
                e.device_tag === "PRO_5_ACT_TEMP" ||
                e.device_tag === "PRO_6_ACT_TEMP" ||
                e.device_tag === "PRO_7_ACT_TEMP" ||
                e.device_tag === "PRO_8_ACT_TEMP" ||
                e.device_tag === "BIG_ACT_TEMP"
            )?.device_tag || "",

          disabled: true,
        },
        // {
        //   name: "prong3TimeHours",
        //   label: "Total Cycle (Hr)",
        //   disabled: true,
        //   value: prong3Data ? prong3Data[0]?.cycle_time_hours : "",
        // },
        {
          name: "prog3StartDate",
          label: "Cycle Start Date",
          value: prong3Data
            ? prong3Data[0]?.cycle_start_time
              ? dayjs(prong3Data[0].cycle_start_time).format("YYYY-MM-DD")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "prog3StartTime",
          label: "Cycle Start Time",
          value: prong3Data
            ? prong3Data[0]?.cycle_start_time
              ? dayjs(prong3Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "prog3Operator",
        //   label: "Cycle Start Operator Name",
        //   value: prong3Data ? prong3Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "prog3StartOperator",
          label: "Cycle Start Operator Name",
          type: "multiselectOperator",
          value: formData.prog3StartOperator,
          options: operatorListData,
          apiResponse: prong3Data,
        },
        {
          name: "prog3EndDate",
          label: "Cycle End Date",
          disabled: true,
          value: prong3Data
            ? prong3Data[0]?.cycle_end_time
              ? dayjs(prong3Data[0].cycle_end_time).format("YYYY-MM-DD")
              : "--"
            : "--",
        },
        {
          name: "prog3EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: prong3Data
            ? prong3Data[0]?.cycle_end_time
              ? dayjs(prong3Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "prong3Supervisor",
        //   label: "Cycle End Operator Name",
        //   disabled: true,
        //   value: prong3Data ? prong3Data[0]?.supervisor : "",
        // },
        {
          name: "prog3EndOperator",
          label: "Cycle End Operator Name",
          type: "multiselectOperator",
          value: formData.prog3EndOperator,
          options: operatorListData,
          apiResponse: prong3Data,
        },
      ],
    },
    {
      x: 920,
      y: 410,
      image: ProductionLineImages.acConditing,
      label: "Extra AC Conditioning",
      machineData: "Extra AC Conditioning",
      DeviceMatch: "Extra AC Conditioning",
      fields: [
        {
          name: "extra_batch_no",
          label: "Batch No",
          type: "extra_batch_no",
          value: formData.extra_batch_no,
        },
        {
          name: "max_temp",
          label: "Actual Temp",
          value:
            mergedArray.find((e) => e.device_tag == "EXTRA_AC_TEMP")?.[
              "tagValue"
            ] || "",
          deviceTag: "EXTRA_AC_TEMP",
          // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
          disabled: true,
        },

        {
          name: "extraAcConditionerRE",
          label: "RE/SC",
          value: extraAcConditioningData
            ? extraAcConditioningData.map((e) => e.sc_re).join(",")
            : "",
          disabled: true,
        },
        {
          name: "extraAcConditionerBinNo",
          label: "BIN No",
          value: extraAcConditioningData
            ? extraAcConditioningData.map((e) => e.bin_number).join(",")
            : "",
          disabled: true,
          // value: disableFieldFormData.extraAcConditionerBinNo,
          // value: mqttData.find((e) => e.WASHING_TEMP)?.WASHING_TEMP || "",
        },
        {
          name: "extraAcConditionerqty",
          label: "QTY",
          value: extraAcConditioningData
            ? extraAcConditioningData.reduce(
                (sum, item) => sum + (Number(item.quantity) || 0),
                0
              )
            : 0,
          disabled: true,
        },

        {
          name: "extraAcConditionerStartDate",
          label: "IN DATE",
          value: extraAcConditioningData
            ? extraAcConditioningData[0]?.cycle_start_time
              ? dayjs(extraAcConditioningData[0].cycle_start_time).format(
                  "YYYY-MM-DD"
                )
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "extraAcConditionerStartTime",
          label: "IN TIME",
          value: extraAcConditioningData
            ? extraAcConditioningData[0]?.cycle_start_time
              ? dayjs(extraAcConditioningData[0].cycle_start_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "extraAcConditionerEndDate",
          label: "OUT DATE",
          value: extraAcConditioningData
            ? extraAcConditioningData[0]?.cycle_end_time
              ? dayjs(extraAcConditioningData[0].cycle_end_time).format(
                  "YYYY-MM-DD"
                )
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "extraAcConditionerEndTime",
          label: "OUT TIME",
          value: extraAcConditioningData
            ? extraAcConditioningData[0]?.cycle_end_time
              ? dayjs(extraAcConditioningData[0].cycle_end_time).format(
                  "HH:mm:ss"
                )
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "extraAcoperator",
        //   label: "OPERATOR",
        //   value: extraAcConditioningData
        //     ? extraAcConditioningData[0]?.operator
        //     : "",
        //   disabled: true,
        // },
        {
          name: "extraAcOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.extraAcOperator,
          options: operatorListData,
          apiResponse: extraAcConditioningData,
        },
      ],
    },
    {
      x: 1050,
      y: 410,
      image: ProductionLineImages.electricalTest,
      label: "Electrical Test",
      machineData: "Electrical Test",
      fields: [
        {
          name: "electricBatchNo",
          label: "Batch No",
          type: "electricBatchNo",
          value: electricTestData,
        },
        {
          name: "electricgOperator",
          label: "Operator Name",
          type: "multiselectOperator",
          value: formData.electricOperator,
          options: operatorListData,
          apiResponse: electricTestData,
        },
      ],
    },
    {
      x: 150,
      y: 560,
      image: ProductionLineImages.boxPacking,
      label: "Box Packing",
      machineData: "Box Packing",
    },
    {
      x: 370,
      y: 560,
      image: ProductionLineImages.polyBag,
      label: "Polybag Packing",
      machineData: "Poly Bag Policing",
    },
    {
      x: 520,
      y: 560,
      image: ProductionLineImages.pairing,
      label: "Pairing",
      machineData: "Pairing",
    },
    {
      x: 670,
      y: 560,
      image: ProductionLineImages.printing,
      label: "Printing",
      machineData: "Printing",
    },
    {
      x: 870,
      y: 560,
      image: ProductionLineImages.outFeed,
      label: "Final Visual Inspection",
      machineData: "Final Visual Inspection",
    },
    {
      x: 1070,
      y: 560,
      image: ProductionLineImages.tumbleOven,
      label: "Prong Oven",
      DeviceMatch: "Prong Oven",
      machineData: "Prong Oven 4",
      fields: [
        // {
        //   name: "prong4_batch_no",
        //   label: "Batch No",
        //   disabled: true,
        //   value: prong4Data
        //     ? prong4Data.map((e) => e.batch_type).join(",")
        //     : "",
        // },
        {
          name: "temp",
          label: "Temp (°C)",
          value: mergedTrackingArray
            ? mergedTrackingArray.find(
                (e) =>
                  e.device_tag === "PRO_1_ACT_TEMP" ||
                  e.device_tag === "PRO_2_ACT_TEMP" ||
                  e.device_tag === "PRO_3_ACT_TEMP" ||
                  e.device_tag === "PRO_4_ACT_TEMP" ||
                  e.device_tag === "PRO_5_ACT_TEMP" ||
                  e.device_tag === "PRO_6_ACT_TEMP" ||
                  e.device_tag === "PRO_7_ACT_TEMP" ||
                  e.device_tag === "PRO_8_ACT_TEMP" ||
                  e.device_tag === "BIG_ACT_TEMP"
              )?.tagValue || ""
            : "",
          // deviceTag: getDeviceTag("Prong Oven 4"),
          deviceTag:
            mergedTrackingArray.find(
              (e) =>
                e.device_tag === "PRO_1_ACT_TEMP" ||
                e.device_tag === "PRO_2_ACT_TEMP" ||
                e.device_tag === "PRO_3_ACT_TEMP" ||
                e.device_tag === "PRO_4_ACT_TEMP" ||
                e.device_tag === "PRO_5_ACT_TEMP" ||
                e.device_tag === "PRO_6_ACT_TEMP" ||
                e.device_tag === "PRO_7_ACT_TEMP" ||
                e.device_tag === "PRO_8_ACT_TEMP" ||
                e.device_tag === "BIG_ACT_TEMP"
            )?.device_tag || "",

          disabled: true,
        },
        // {
        //   name: "prong4TimeHours",
        //   label: "Total Cycle (Hr)",
        //   disabled: true,
        //   value: prong4Data ? prong4Data[0]?.cycle_time_hours : "",
        // },
        {
          name: "prog4StartDate",
          label: "Cycle Start Date",
          value: prong4Data
            ? prong4Data[0]?.cycle_start_time
              ? dayjs(prong4Data[0].cycle_start_time).format("YYYY-MM-DD")
              : "--"
            : "--",
          disabled: true,
        },
        {
          name: "prog4StartTime",
          label: "Cycle Start Time",
          value: prong4Data
            ? prong4Data[0]?.cycle_start_time
              ? dayjs(prong4Data[0].cycle_start_time).format("HH:mm:ss")
              : "--"
            : "--",
          disabled: true,
        },
        // {
        //   name: "prog4Operator",
        //   label: "Cycle Start Operator Name",
        //   value: prong4Data ? prong4Data[0]?.operator : "",
        //   disabled: true,
        // },
        {
          name: "prog4StartOperator",
          label: "Cycle Start Operator Name",
          type: "multiselectOperator",
          value: formData.prog4StartOperator,
          options: operatorListData,
          apiResponse: prong4Data,
        },
        {
          name: "prog4EndDate",
          label: "Cycle End Date",
          disabled: true,
          value: prong4Data
            ? prong4Data[0]?.cycle_end_time
              ? dayjs(prong4Data[0].cycle_end_time).format("YYYY-MM-DD")
              : "--"
            : "--",
        },
        {
          name: "prog4EndTime",
          label: "Cycle End Time",
          disabled: true,
          value: prong4Data
            ? prong4Data[0]?.cycle_end_time
              ? dayjs(prong4Data[0].cycle_end_time).format("HH:mm:ss")
              : "--"
            : "--",
        },
        // {
        //   name: "prong4Supervisor",
        //   label: "Cycle End Operator Name",
        //   disabled: true,
        //   value: prong4Data ? prong4Data[0]?.supervisor : "",
        // },
        {
          name: "prog4EndOperator",
          label: "Cycle End Operator Name",
          type: "multiselectOperator",
          value: formData.prog4EndOperator,
          options: operatorListData,
          apiResponse: prong4Data,
        },
      ],
    },
  ];

  // const data = trackingData.find((e) => e.status === "processing");

  // const matchData = processSteps.find(
  //   (e) => e?.machineData == data?.station_name
  // );
  const [matchData, setMatchedData] = useState();

  useEffect(() => {
    if (
      stationName == "Static Leaching" ||
      stationName === "Prong Oven 1" ||
      stationName === "Prong Oven 2" ||
      stationName === "Prong Oven 3" ||
      stationName === "Prong Oven 4" ||
      stationName === "Prong Oven 5" ||
      stationName === "Prong Oven 6" ||
      stationName === "Prong Oven 7" ||
      stationName === "Prong Oven 8"
    ) {
      const matchData = processData.find((e) => e?.machineData == stationName);

      setMatchedData(matchData);
    } else {
      const matchData = processData.find(
        (e) => e?.machineData == (trackingStationName || stationName)
      );
      console.log("hksdufhsdkfhdhd", matchData);
      setMatchedData(matchData);
    }
  }, [trackingStationName, stationName, processData]);

  const hasHandledClick = useRef(false);

  console.log("matchDatamatchData", matchData);
  // useEffect(() => {
  //   if (matchData && !hasHandledClick.current) {
  //     handleClick(matchData);
  //     // hasHandledClick.current = true;
  //   }
  // }, [matchData]);

  const prevMatchData = useRef(null);
  useEffect(() => {
    if (
      matchData &&
      matchData !== prevMatchData.current &&
      !hasFetched.current
    ) {
      // hasFetched.current = true; // Prevent further calls
      // prevMatchData.current = matchData; // Track the last called matchData
      handleClick(matchData);
    }
  }, [matchData]);

  useEffect(() => {
    const matchStation =
      stationName === "Static Leaching" ||
      stationName === "Prog Oven 1" ||
      stationName === "Prog Oven 2" ||
      stationName === "Prog Oven 3" ||
      stationName === "Prog Oven 4" ||
      stationName === "Prog Oven 5" ||
      stationName === "Prog Oven 6" ||
      stationName === "Prog Oven 7" ||
      stationName === "Prog Oven 8"
        ? stationName
        : trackingStationName;
    const qrstringData = processSteps.find(
      (e) => e.machineData === matchStation
    );
    if (!qrstringData) return;

    if (selectedStation?.label === stationName) return;

    // setOpen(true);
    // setSelectedStation(qrstringData);

    // const apiFunctions = {
    //   Leaching: handleGetLeaching,
    //   "Tunnel Oven": handleGetTunnelOven,
    //   Stripping: handleGetStrippingData,
    //   "Static Leaching": handleGetStaticLeachingData,
    //   "Washing Machine 2": handleGetgetWashineMachine2Data,
    //   "Washing Machine 1": handleGetWashing1Data,
    //   "Tumble Drying 2": handleGetTumbleDrying2,
    //   "Tumble Drying 1": handleGetTumbleDrying1,
    //   "Prong Oven 4": handleGetProngOven4,
    //   "Prong Oven 3": handleGetProngOven3,
    //   "Prong Oven 2": handleGetProngOven2,
    //   "Prong Oven 1": handleGetProngOven,
    //   "UID Printing" : getUidDeails,
    //   "Visual Inspection" : getVisualInspection,
    //   "Electrical Test" : getElectricTestDataAPI,
    //   Autoclave: handleGetAutoClave,
    //   Cutting: handleGetCuttingData,
    //   "AC Conditioning": handleGetAcConditioningData,
    //   "Hanco washing": handleGetHancoMachineData,
    //   Chlorination: handleGetChlorinationData,
    //   "Extra AC Conditioning": handleGetExtraConditionerData,
    // };

    // if (qrstringData?.label && apiFunctions[qrstringData.label]) {
    //   apiFunctions[qrstringData.label]();
    // }

    // if (matchData?.machineData && apiFunctions[matchData.machineData]) {
    //   apiFunctions[matchData.machineData]();
    // }

    // const updatedFormData = {};

    // if (Array.isArray(qrstringData?.fields)) {
    //   qrstringData.fields.forEach((field) => {
    //     updatedFormData[field.name] = field.value || "";
    //   });
    // }

    // if (Array.isArray(matchData?.fields)) {
    //   matchData.fields.forEach((field) => {
    //     updatedFormData[field.name] = field.value || "";
    //   });
    // }

    // setFormData(updatedFormData);
  }, [mqttData, stationPopup, matchData, mergedTrackingArray, selectedStation]);

  const tray_assigned_batch =
    JSON.parse(localStorage.getItem("tray_assigned_batch")) || [];

  return (
    <>
      {topic.length > 0 && (
        <MqttData
          topics={topic}
          setMqttTagData={setMqttData}
          allData={allStationData}
        />
      )}

      {trackingTopic?.length > 0 && (
        <MqttData
          topics={
            Array.isArray(trackingTopic) ? trackingTopic : [trackingTopic]
          }
          setMqttTagData={setTrackingMqtttData}
        />
      )}
      <ToastContainer />

      {/* Visual Inspection */}
      {isVisualInspection ? (
        <ProductionLineVisualInspection closeModal={setIsVisualInspection} />
      ) : (
        <div className="min-h-screen bg-[#f5f3ff] p-8 dashboard-wrapper page-wraper">
          <div className="page-header">
            <Link to="/production-line" className="page-back-btn">
              <ArrowBackIcon />
              {batchTypeData ? (
                <span>
                  Production Line
                  <span className="capsule-button" style={{ marginLeft: 8 }}>
                    {batchTypeData}
                  </span>
                </span>
              ) : batchType ? (
                <span>
                  Production Line
                  {batchType.map((batch, index) => (
                    <span
                      key={index}
                      className="capsule-button"
                      style={{ marginLeft: 8 }}
                    >
                      {batch}
                    </span>
                  ))}
                </span>
              ) : tray_assigned_batch ? (
                <span>
                  Production Line
                  {tray_assigned_batch.map((batch, index) => (
                    <span
                      key={index}
                      className="capsule-button"
                      style={{ marginLeft: 8 }}
                    >
                      {batch}
                    </span>
                  ))}
                </span>
              ) : (
                <span>Production Line</span>
              )}
            </Link>
          </div>
          <div className="max-w-6xl mx-auto">
            <svg
              viewBox="-50 50 1250 600"
              className="w-full"
              // style={{ maxHeight: "80vh" }}
            >
              <path
                d="M50 100 L1100 100 
                            Q1150 100 1150 150
                            L1150 200 
                            Q1150 250 1100 250
                            L100 250
                            Q50 250 50 300
                            L50 350 
                            Q50 400 100 400
                            L1100 400
                            Q1150 400 1150 450
                            L1150 500 
                            Q1150 550 1100 550
                            L150 550"
                fill="none"
                stroke="#1e3a8a"
                stroke-width="4"
              />
              {/* Dynamically render process stations */}
              {processSteps.map((station) => (
                <ProcessStation
                  key={`${station.label}-${station.x}-${station.y}`}
                  x={station.x}
                  y={station.y}
                  image={station.image}
                  label={station.label}
                  machineData={station.machineData}
                  status={status[station.label]}
                  onClick={() => handleClick(station)}
                  trackingData={trackingData}
                  stationName={stationName}
                />
              ))}
            </svg>
          </div>

          {/* DIALOG BOX */}
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={
              (scannedMachine !== "Static Leaching" && selectedStation?.label !== "Static Leaching") &&
             (scannedMachine !== "Prong Oven" && selectedStation?.label !== "Prong Oven") && scannedMachine !== "Big Oven"
                ? "xs"
                : "md"
            }
            fullWidth
          >
            <DialogTitle className="productionline-dialog-title">
              {scannedMachine ? scannedMachine : selectedStation?.machineData
                ? selectedStation?.machineData
                : selectedStation?.label}{" "}
            </DialogTitle>
            <DialogContent className="mt-3">
              {(scannedMachine !== "Static Leaching"  && selectedStation?.label !== "Static Leaching") &&
             (scannedMachine !== "Prong Oven" && selectedStation?.label !== "Prong Oven")
              && (scannedMachine !== "Big Oven") ? (
                selectedStation?.fields?.map((field) =>
                  field.label === "Tunnel Oven actual temperture zone wise" ? (
                    <div
                      key={field.name}
                      style={{ marginBottom: "15px", marginTop: "10px" }}
                    >
                      <label style={{ display: "block", fontSize: "14px" }}>
                        {field.label}
                      </label>
                      <div className="d-flex flex-wrap gap-2">
                        {[...Array(8)].map((_, index) => {
                          const setTemp = Math.round(
                            mergedArray.find(
                              (e) => e[`TUNL_OVN_Z${index + 1}_SET_TEMP`]
                            )?.[`TUNL_OVN_Z${index + 1}_SET_TEMP`] || 0
                          );

                          const actualTemp = Math.round(
                            mergedArray.find(
                              (e) => e[`TUNL_OVN_Z${index + 1}_ACT_TEMP`]
                            )?.[`TUNL_OVN_Z${index + 1}_ACT_TEMP`] || 0
                          );

                          return (
                            <div
                              key={index}
                              className="flex flex-col items-center"
                              style={{ width: "calc(25% - 8px)" }}
                            >
                              <span
                                style={{
                                  display: "block",
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  textAlign: "center",
                                }}
                              >
                                {index + 1}
                              </span>
                              <div className="d-flex items-center">
                                <TextField
                                  name={`zone_${index + 1}_temp`}
                                  value={setTemp} // SET_TEMP without decimal
                                  onChange={handleChange}
                                  size="small"
                                  variant="filled"
                                  fullWidth
                                  style={{ width: "max-content" }}
                                  className="production-line-popup-input-field"
                                  InputProps={{
                                    disableUnderline: true,
                                    style: {
                                      width: "40px",
                                      color: "white",
                                      paddingRight: "0px",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      paddingRight: "0px",
                                    },
                                  }}
                                  disabled
                                />
                                <div
                                  className="d-flex justify-content-center align-items-center"
                                  style={{
                                    width: "50px",
                                    border: "1px solid #E1E1E1",
                                    borderRadius: "0px 6px 6px 0px",
                                    color: "#000",
                                  }}
                                >
                                  <span>{actualTemp}</span>
                                  <span>°C</span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : field.disabled !== true ? (
                    <div
                      key={field.name}
                      style={{ marginBottom: "10px", marginTop: "10px" }}
                    >
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        {field.label}
                      </label>

                      {field.type == "leachingBatch" ? (
                        <MultiSelectWithCheckbox
                          options={leachingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="leachingBatch"
                        />
                      ) : field.type == "electricBatchNo" ? (
                        <MultiSelectWithCheckbox
                          options={electricTestData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                        />
                      ) : field.type == "visualInspectionBatchNo" ? (
                        <MultiSelectWithCheckbox
                          options={visualInspectionData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                        />
                      ) : field.type == "uidPrintingBatchNo" ? (
                        <MultiSelectWithCheckbox
                          options={uidPrintingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                        />
                      ) : field.type == "multiselectOperator" ? (
                        <MultiSelectWithCheckbox
                          options={operatorListData ? operatorListData : []}
                          type={"operator_name"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                          apiResponse={field.apiResponse}
                        />
                      ) : field.type == "visualInspectionBatchNo" ? (
                        <MultiSelectWithCheckbox
                          options={leachingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                        />
                      ) : field.type == "uidPrintingBatchNo" ? (
                        <MultiSelectWithCheckbox
                          options={leachingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                        />
                      ) : field.type == "multiselectOperator" ? (
                        <MultiSelectWithCheckbox
                          options={
                            Array.isArray(operatorListData)
                              ? operatorListData
                              : []
                          }
                          type={"operator_name"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName={field.name}
                          apiResponse={field.apiResponse}
                        />
                      ) : field.type == "tunnelOvenBatch" ? (
                        <MultiSelectWithCheckbox
                          options={tunnelOvenData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="tunnelOvenBatch"
                        />
                      ) : field.type == "batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={strippingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="batch_no"
                        />
                      ) : field.type == "tumbleDryingBatch" ? (
                        <MultiSelectWithCheckbox
                          options={tumbledrying2Data}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="tumbleDryingBatch"
                        />
                      ) : field.type == "washing2_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={washing2Data}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="washing2_batch_no"
                        />
                      ) : field.type == "cutting_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={cuttingData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="cutting_batch_no"
                        />
                      ) : field.type == "autoClave_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={autoClaveData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="autoClave_batch_no"
                        />
                      ) : field.type == "tumbledrying1_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={tumbledrying1Data}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="tumbledrying1_batch_no"
                        />
                      ) : field.type == "washing1_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={washing1Data}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="washing1_batch_no"
                        />
                      ) : field.type == "ac_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={acConditioningData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="ac_batch_no"
                        />
                      ) : field.type == "hancoMachine_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={hancoMachine}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="hancoMachine_batch_no"
                        />
                      ) : field.type == "chlorination_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={chlorinationData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="chlorination_batch_no"
                        />
                      ) : field.type == "extra_batch_no" ? (
                        <MultiSelectWithCheckbox
                          options={extraAcConditioningData}
                          type={"batch_no"}
                          selectedValues={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fieldName="extra_batch_no"
                        />
                      ) : field.type == "dropdown" ? (
                        <Select
                          value={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name] || ""
                          }
                          onChange={(e) => handleChangeData(e, field.name)}
                          fullWidth
                          size="small"
                          variant="filled"
                          name={field.name}
                          className="production-line-popup-input-field-data"
                          sx={{
                            backgroundColor: "#f0f0f0",
                            "&:hover": { backgroundColor: "#e0e0e0" },
                            "& .MuiFilledInput-root": {
                              backgroundColor: "#f0f0f0",
                            },
                          }}
                        >
                          {field.options.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : field.type == "chlorinationDropdown" ? (
                        <>
                          <Select
                            value={
                              disableFieldFormData[field.name]
                                ? disableFieldFormData[field.name]
                                : formData[field.name] || ""
                            }
                            onChange={(e) => handleChangeData(e, field.name)}
                            fullWidth
                            size="small"
                            variant="filled"
                            name={field.name}
                            className="production-line-popup-input-field-data"
                            sx={{
                              backgroundColor: "#f0f0f0",
                              "&:hover": {
                                backgroundColor: "#e0e0e0",
                              },
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#f0f0f0",
                              },
                            }}
                          >
                            {field.options.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </>
                      ) : (
                        <TextField
                          name={field.name}
                          value={
                            disableFieldFormData[field.name]
                              ? disableFieldFormData[field.name]
                              : formData[field.name]
                          }
                          onChange={handleChangeDisable}
                          fullWidth
                          size="small"
                          variant="filled"
                          InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  onClick={() => console.log("Edit Clicked")}
                                  disabled={field.disabled}
                                >
                                  <img
                                    src={images.editIcon}
                                    alt=""
                                    style={{ pointerEvents: "none" }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          className="production-line-popup-input-field"
                          disabled={field.disabled}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      key={field.name}
                      style={{ marginBottom: "10px", marginTop: "10px" }}
                    >
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        {field.label}
                      </label>
                      <TextField
                        name={field.name}
                        value={formData[field.name] || field.value}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        disabled={field.disabled}
                        style={{
                          border:
                            field.label == "Water Level (Litres)"
                              ? "1px solid black"
                              : "",
                          borderRadius:
                            field.label == "Water Level (Litres)" ||
                            field.name == "EMERGENCY"
                              ? "4px 4px 0px 0px"
                              : "",
                          backgroundColor:
                            field.label == "EMERGENCY"
                              ? mergedArray.find(
                                  (e) => e.device_tag == "EMERGENCY"
                                )?.["tagValue"] == 1
                                ? "Red"
                                : ""
                              : "",
                        }}
                      />
                    </div>
                  )
                )
              ) : (scannedMachine == "Static Leaching" && selectedStation?.label == "Static Leaching") ? (
                <>
                  <Grid container spacing={4}>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      style={{ height: "483px", overflow: "auto" }}
                    >
                      <Table className="bin-Table">
                        <TableHead
                          sx={{ backgroundColor: "#0a3d91" }}
                          className="bin-table-th"
                        >
                          <TableRow className="bin-table-tr">
                            <TableCell
                              sx={{ color: "white" }}
                              className="bin-table-td"
                            ></TableCell>
                            <TableCell
                              sx={{ color: "white", fontWeight: "bold" }}
                              className="bin-table-td"
                            >
                              BIN No
                            </TableCell>
                            <TableCell
                              sx={{ color: "white", fontWeight: "bold" }}
                              className="bin-table-td"
                            >
                              Batch No
                            </TableCell>
                            <TableCell
                              sx={{ color: "white", fontWeight: "bold" }}
                              className="bin-table-td"
                            >
                              Duration
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* {data.length > 0
                            ? data.map((row) => ( */}
                          {staticLeachingBinData.length > 0
                            ? staticLeachingBinData.map((row) => (
                                <TableRow key={row.id} className="bin-table-tr">
                                  {console.log("fdcjnkjmf", row)}
                                  <TableCell className="bin-table-td">
                                    <Checkbox
                                      checked={selected.includes(row.id)}
                                      // onChange={() =>
                                      //   handleSelect(row.id, row.binNo,)
                                      // }
                                      onChange={() =>
                                        handleSelect(
                                          row.id,
                                          row.bin_no,
                                          row.batch
                                        )
                                      }
                                      disabled={
                                        selected.length > 0 &&
                                        !selected.includes(row.id)
                                      }
                                      sx={{
                                        color: "white",
                                        "&.Mui-checked": { color: "white" },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {/* {row?.binNo || "-"} */}
                                    {row?.bin_no || "-"}
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {/* - */}
                                    {Array.isArray(row.batch_type) &&
                                    row.batch_type.length > 0
                                      ? row.batch_type.join(", ")
                                      : "-"}
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {row.duration || "-"}
                                  </TableCell>
                                </TableRow>
                              ))
                            : staticBinData?.length > 0
                            ? staticBinData.map((row) => (
                                <TableRow key={row.id} className="bin-table-tr">
                                  <TableCell className="bin-table-td">
                                    <Checkbox
                                      checked={selected.includes(row.id)}
                                      onChange={() =>
                                        handleSelect(
                                          row.id,
                                          row.bin_no,
                                          row.batch
                                        )
                                      }
                                      disabled={
                                        selected.length > 0 &&
                                        !selected.includes(row.id)
                                      }
                                      sx={{
                                        color: "white",
                                        "&.Mui-checked": { color: "white" },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {row?.bin_no || "-"}
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {Array.isArray(row.batch_type) &&
                                    row.batch_type.length > 0
                                      ? row.batch_type.join(", ")
                                      : "-"}
                                  </TableCell>
                                  <TableCell className="bin-table-td">
                                    {row.duration || "-"}
                                  </TableCell>
                                </TableRow>
                              ))
                            : null}
                        </TableBody>
                      </Table>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {selectedStation?.fields?.map((field) =>
                        !field.disabled ? (
                          <div
                            key={field.name}
                            style={{ marginBottom: "10px", marginTop: "10px" }}
                          >
                            <label
                              style={{ display: "block", fontSize: "14px" }}
                              className="mb-1"
                            >
                              {field.label}
                            </label>
                            {field.type == "multiselectOperator" ? (
                              <MultiSelectWithCheckbox
                                options={operatorListData}
                                type={"operator_name"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                                apiResponse={field.apiResponse}
                              />
                            ) : field.type == "electricBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={electricTestData}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "visualInspectionBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={visualInspectionData}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "uidPrintingBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={uidPrintingData}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "multiselectOperator" ? (
                              <MultiSelectWithCheckbox
                                options={operatorListData}
                                type={"operator_name"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                                apiResponse={field.apiResponse}
                              />
                            ) : (
                              <TextField
                                name={field.name}
                                value={
                                  disableFieldFormData[field.name] ||
                                  formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fullWidth
                                size="small"
                                variant="filled"
                                InputProps={{
                                  disableUnderline: true,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          console.log("Edit Clicked")
                                        }
                                        disabled={field.disabled}
                                      >
                                        <img
                                          src={images.editIcon}
                                          alt=""
                                          style={{ pointerEvents: "none" }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                className="production-line-popup-input-field"
                                disabled={field.disabled}
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            key={field.name}
                            style={{ marginBottom: "10px", marginTop: "10px" }}
                          >
                            <label
                              style={{ display: "block", fontSize: "14px" }}
                              className="mb-1"
                            >
                              {field.label}
                            </label>
                            <TextField
                              name={field.name}
                              value={formData[field.name] || field.value}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              variant="filled"
                              InputProps={{ disableUnderline: true }}
                              className="production-line-popup-input-field"
                              disabled={field.disabled}
                              style={{
                                border:
                                  field.label === "Water Level (Litres)"
                                    ? "1px solid black"
                                    : "",
                                borderRadius:
                                  field.label === "Water Level (Litres)" ||
                                  field.name === "EMERGENCY"
                                    ? "4px 4px 0px 0px"
                                    : "",
                                backgroundColor:
                                  field.label === "EMERGENCY" &&
                                  mergedArray.find(
                                    (e) => e.device_tag === "EMERGENCY"
                                  )?.tagValue === 1
                                    ? "Red"
                                    : "",
                              }}
                            />
                          </div>
                        )
                      )}
                      {!UpdateButtonData ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleUpdate}
                          fullWidth
                          style={{
                            marginTop: "15px",
                            backgroundColor: "#0d3b66",
                          }}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleScanData(selectedStation)}
                          fullWidth
                          style={{
                            marginTop: "15px",
                            backgroundColor: "#0d3b66",
                          }}
                        >
                          Scan a Tray
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container spacing={4}>
                    {/* Left Section - Table */}
                    <Grid item xs={12} md={7} lg={7}>
                      <div style={{ height: "450px", overflow: "auto" }}>
                        <Table className="bin-Table">
                          <TableHead
                            sx={{ backgroundColor: "#0a3d91" }}
                            className="bin-table-th"
                          >
                            <TableRow className="bin-table-tr">
                              <TableCell
                                sx={{ color: "white" }}
                                className="bin-table-td"
                              ></TableCell>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                                className="bin-table-td"
                              >
                                Select Trolly
                              </TableCell>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                                className="bin-table-td"
                              >
                                Batch No
                              </TableCell>
                              <TableCell
                                sx={{ color: "white", fontWeight: "bold" }}
                                className="bin-table-td"
                              >
                                Duration
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {prongOvenTrollyData.length > 0
                              ? prongOvenTrollyData.map((row) => (
                                  <TableRow
                                    key={row.id}
                                    className="bin-table-tr"
                                  >
                                    <TableCell className="bin-table-td">
                                      <Checkbox
                                        checked={trollySelected.includes(
                                          row.id
                                        )} // Direct comparison instead
                                        onChange={() =>
                                          handleSelectData(
                                            row.id,
                                            row.trolley,
                                            row.batch
                                          )
                                        }
                                        sx={{
                                          color: "white",
                                          "&.Mui-checked": { color: "white" },
                                        }}
                                        disabled={
                                          trollySelected.length > 0 &&
                                          !trollySelected.includes(row.id)
                                        }
                                      />
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {row.trolley}
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {row?.batch_type?.length > 0
                                        ? row.batch_type.join(", ")
                                        : ""}
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {row.duration || "-"}
                                    </TableCell>
                                  </TableRow>
                                ))
                              : trollyData.length > 0
                              ? trollyData.map((row) => (
                                  <TableRow
                                    key={row.id}
                                    className="bin-table-tr"
                                  >
                                    <TableCell className="bin-table-td">
                                      <Checkbox
                                        checked={trollySelected.includes(
                                          row.id
                                        )} // Direct comparison instead of includes()
                                        onChange={() =>
                                          handleSelectData(
                                            row.id,
                                            row.trolley,
                                            row.batch
                                          )
                                        }
                                        sx={{
                                          color: "white",
                                          "&.Mui-checked": { color: "white" },
                                        }}
                                        disabled={
                                          trollySelected.length > 0 &&
                                          !trollySelected.includes(row.id)
                                        }
                                      />
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {row.trolley}
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {Array.isArray(row.batch_type) &&
                                      row.batch_type.length > 0
                                        ? row.batch_type.join(", ")
                                        : "-"}
                                    </TableCell>
                                    <TableCell className="bin-table-td">
                                      {row.duration || "-"}
                                    </TableCell>
                                  </TableRow>
                                ))
                              : null}
                          </TableBody>
                        </Table>
                      </div>

                      {!UpdateButtonData ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleUpdate}
                          fullWidth
                          style={{
                            marginTop: "15px",
                            backgroundColor: "#0d3b66",
                          }}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleScanData(selectedStation)}
                          fullWidth
                          style={{
                            marginTop: "15px",
                            backgroundColor: "#0d3b66",
                          }}
                        >
                          Scan a Tray
                        </Button>
                      )}
                    </Grid>

                    {/* Right Section - Form */}
                    <Grid item xs={12} md={5} lg={5}>
                      {selectedStation?.fields?.map((field) =>
                        field.disabled !== true ? (
                          <div
                            key={field.name}
                            style={{ marginBottom: "10px", marginTop: "10px" }}
                          >
                            <label
                              style={{ display: "block", fontSize: "14px" }}
                              className="mb-1"
                            >
                              {field.label}
                            </label>
                            {field.type == "multiselectOperator" ? (
                              <MultiSelectWithCheckbox
                                options={operatorListData}
                                type={"operator_name"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                                apiResponse={field.apiResponse}
                              />
                            ) : field.type == "electricBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={electricTestData}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "visualInspectionBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={visualInspectionData}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "uidPrintingBatchNo" ? (
                              <MultiSelectWithCheckbox
                                options={field.options}
                                type={"batch_no"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                              />
                            ) : field.type == "multiselectOperator" ? (
                              <MultiSelectWithCheckbox
                                options={operatorListData}
                                type={"operator_name"}
                                selectedValues={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fieldName={field.name}
                                apiResponse={field.apiResponse}
                              />
                            ) : (
                              <TextField
                                name={field.name}
                                value={
                                  disableFieldFormData[field.name]
                                    ? disableFieldFormData[field.name]
                                    : formData[field.name]
                                }
                                onChange={handleChangeDisable}
                                fullWidth
                                size="small"
                                variant="filled"
                                InputProps={{
                                  disableUnderline: true,
                                  sx: { width: "100%" },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          console.log("Edit Clicked")
                                        }
                                        disabled={field.disabled}
                                      >
                                        <img
                                          src={images.editIcon}
                                          alt=""
                                          style={{ pointerEvents: "none" }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                className="production-line-popup-input-field"
                                disabled={field.disabled}
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            key={field.name}
                            style={{ marginBottom: "10px", marginTop: "10px" }}
                          >
                            <label
                              style={{ display: "block", fontSize: "14px" }}
                              className="mb-1"
                            >
                              {field.label}
                            </label>
                            <TextField
                              name={field.name}
                              value={formData[field.name] || field.value}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              variant="filled"
                              InputProps={{
                                disableUnderline: true,
                                sx: { width: "100%" },
                              }}
                              className="production-line-popup-input-field"
                              disabled={field.disabled}
                              style={{
                                border:
                                  field.label === "Water Level (Litres)"
                                    ? "1px solid black"
                                    : "",
                                borderRadius:
                                  field.label === "Water Level (Litres)" ||
                                  field.name === "EMERGENCY"
                                    ? "4px 4px 0px 0px"
                                    : "",
                                backgroundColor:
                                  field.label === "EMERGENCY"
                                    ? mergedArray.find(
                                        (e) => e.device_tag === "EMERGENCY"
                                      )?.["tagValue"] === 1
                                      ? "Red"
                                      : ""
                                    : "",
                              }}
                            />
                          </div>
                        )
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
              {console.log(
                "selectedStationselectedStation",
                selectedStation?.label
              )}
              {selectedStation?.label != "Static Leaching" &&
              selectedStation?.label != "Prong Oven" ? (
                !UpdateButtonData ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpdate}
                    fullWidth
                    style={{ marginTop: "15px", backgroundColor: "#0d3b66" }}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleScanData(selectedStation)}
                    fullWidth
                    style={{ marginTop: "15px", backgroundColor: "#0d3b66" }}
                  >
                    Scan a Tray
                  </Button>
                )
              ) : (
                ""
              )}
            </DialogContent>
          </Dialog>

          {/* Dipping Parameter Dialog */}
          {dippingPopup && (
            <RobotParameter
              dippingPopup={dippingPopup}
              setDippingPopup={setDippingPopup}
            />
          )}

          <Dialog
            open={ultrasonicPopups}
            onClose={() => setUltrasonicPopups(false)}
            maxWidth="xl"
            fullWidth
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            <Grid container spacing={2}>
              {ultrasonicTanks.map((tank) => (
                <Grid item md={3} key={tank.id}>
                  <DialogTitle className="productionline-dialog-title">
                    Ultrasonic
                  </DialogTitle>
                  <DialogContent
                    style={{ background: "white" }}
                    className="pt-2"
                  >
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        RFID TAG
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.rfid_tag}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Ultrasonic Tank Temp
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.ultrasonic_t_act_temp}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Ultrasonic Tank Time
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.ultrasonic_t_time}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Rinsing Tank Temp
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.rinsing_t_act_temp}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Rinsing Tank Time
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.rinsing_t_time}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Hot Air Dryer Temp
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.h_air_dryr_t_act_temp}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Oven Tank Time
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.oven_tank_time}
                        disabled
                      />
                    </div>

                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Shift
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.shift_name}
                        disabled
                      />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
                      <label
                        style={{ display: "block", fontSize: "14px" }}
                        className="mb-1"
                      >
                        Date & Time
                      </label>
                      <TextField
                        fullWidth
                        size="small"
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        className="production-line-popup-input-field"
                        value={tank.created_at ? dayjs(tank.created_at).format("YYYY/MM/DD HH:mm") : "-"}
                        disabled
                      />
                    </div>
                  </DialogContent>
                </Grid>
              ))}
            </Grid>
          </Dialog>

          {/* {electricTestPopup && (
            <ElectricTestReportData
              electricTestPopup={electricTestPopup}
              setElectricTestPopupTest={setElectricTestPopupTest}
            />
          )} */}
          {/* {finalVisualInspectionPopup && <FinalVisualInspectionData finalVisualInspectionPopup={finalVisualInspectionPopup} setFinalVisualInspectionPopup={setFinalVisualInspectionPopup}/>} */}
        </div>
      )}
    </>
  );
};
export default ProductionLineChart;

function ProcessStation({
  x,
  y,
  image,
  label,
  machineData,
  status,
  onClick,
  trackingData,
  stationName,
}) {
  const station = trackingData.find((e) => e.station_name == machineData);

  const getStatusColor = () => {
    switch (station?.status) {
      case "passed":
        return "green";
      case "processing":
        return "#1e3b8a";
      case "pending":
        return "white";
      case "skipped":
        return "red";
      default:
        return "white";
    }
  };

  const isHighlighted =
    station?.status == "passed" ||
    station?.status == "processing" ||
    station?.status == "pending" ||
    station?.status == "skipped";

  const shouldRenderCircle = ![
    "Final Visual Inspection",
    "Printing",
    "Pairing",
    "Poly Bag Policing",
    "Box Packing",
  ].includes(station?.station_name);

  return (
    <g
      transform={`translate(${x - 30} ${y + 20})`}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      {shouldRenderCircle && (
        <circle
          cx={30}
          cy={-30}
          r={10}
          fill={getStatusColor()}
          stroke={
            station?.status === "pending"
              ? "#1e3a8a"
              : isHighlighted
              ? "none"
              : "#1e3a8a"
          }
          strokeWidth="2"
          style={{
            filter:
              station?.status === "pending"
                ? "none"
                : isHighlighted
                ? `drop-shadow(0px 0px 8px ${getStatusColor()})`
                : "none",
          }}
        />
      )}

      <image href={image} x="20" y="0" width="30" height="30" />
      <text
        x="0"
        y="50"
        style={{ fontSize: "14px" }}
        textAnchor="middle"
        transform="translate(30 0)"
      >
        {label}
      </text>
    </g>
  );
}
